<template>
<div>
    <v-snackbar v-model="error" color="red darken-2">
        <b>{{ errorMessage }} </b>
    </v-snackbar>
    <div v-if="this.employeeData">
        <v-card class="review-card">
            <template>
                <v-stepper v-model="genralStepperIndex" vertical light non-linear>
                    <!-- STEPPER 1 -->
                    <v-stepper-step id="step_1" @click="$vuetify.goTo('#step_1', options)" editable step="1" color="#00635b">
                        <b> {{ $t('pdr.title1') }} </b>
                    </v-stepper-step>
                    <v-form ref="formPart1" v-model="validPart1" :lazy-validation="lazyPart1">
                        <!-- CONTENT OF STEPPER 1 -->
                        <v-stepper-content step="1">
                            <v-card class="mb-12">
                                <References :employeeData="employeeData"></References>
                            </v-card>
                            <v-btn color="red darken-2" class="mr-2 mb-3" @click="printEmployeePDF" style="color: white !important;">
                                <v-icon class="mr-2">mdi-file-pdf-outline</v-icon>{{$t('pdr.reference.print')}}
                            </v-btn>
                            <v-btn v-if="!statusIsEmployeeProposalPart1_2" class="mb-3" color="#00635b" style="color: white !important;" @click="genralStepperIndex = 2; ">{{$t('pdr.reference.beginAssessement')}}<v-icon>mdi-arrow-down</v-icon>
                            </v-btn>
                        </v-stepper-content>

                        <!-- STEPPER 2 -->
                        <div v-if="employeeData.reviewFirstPart">
                            <v-stepper-step v-if="!statusIsEmployeeProposalPart1_2" id="step_2" @click="$vuetify.goTo('#step_2', options)" editable step="2" color="#00635b"> <b>{{$t('pdr.part2.tit')}}</b></v-stepper-step>
                            <!-- CONTENT OF STEPPER 2 -->
                            <v-stepper-content step="2">

                                <v-card class="mb-12">
                                    <!-- Info message : Part 1 and 2 -->
                                    <v-alert class="mr-3 info-text " colored-border border="left" color="#00635b" type="info" elevation="4">
                                        <v-card-text v-html="labels['PDR_PROCESS_'+locale.toUpperCase()]"> </v-card-text>
                                    </v-alert>
                                    <!-- OBJECTIVES 2018 CONTENT  CARD -->
                                    <v-card flat>
                                        <v-card-title class="secondary-titles" id="step_21" @click="$vuetify.goTo('#step_21', options)">
                                            <v-icon color="#8ba79d" class="mr-2">mdi-numeric-1-circle</v-icon> {{employeeData.campaign.year -1}} {{$t('pdr.part2.title1')}}
                                        </v-card-title>
                                        <v-card-text class="ml-5">
                                            <v-alert class="mr-3 info-text margin-top" border="left" colored-border color="#8ba79d" type="info" elevation="4">
                                                <v-card-text v-html="labels['OBJ_ASS_'+locale.toUpperCase()]"> </v-card-text>
                                            </v-alert>

                                            <!-- Tableau Objectives Assessment -->
                                            <template>
                                                <v-simple-table style="margin-top: 25px;">
                                                    <template v-slot:default>
                                                        <thead>
                                                            <tr class="general-background">
                                                                <th class="text-left col-elem border-elem" rowspan="2"><b>{{ $t('pdr.part2.n')}}</b></th>
                                                                <th class="text-left col-elem border-elem" rowspan="2"><b>{{ $t('pdr.part2.ObjectiveName') }}</b></th>
                                                                <th class="text-left col-elem border-elem" rowspan="2" style="width: 40%;"><b>{{ $t('pdr.part2.Description')}}</b></th>
                                                                <th class="text-left col-elem border-elem" rowspan="2"><b>{{ $t('pdr.part2.Indicator')}}</b></th>
                                                                <th class="text-left col-elem border-elem" rowspan="2" style="width: 110px;"><b>{{ $t('pdr.part2.Completion')}}</b></th>
                                                                <th class="text-left col-elem border-elem" rowspan="2"><b>{{ $t('pdr.part2.poids')}}</b></th>
                                                                <th class="text-left col-elem border-elem" colspan="2">
                                                                    <b>{{ $t('pdr.reference.slmanager')}}</b>
                                                                </th>
                                                            </tr>
                                                            <tr class="general-background">
                                                                <th class="text-left col-elem border-elem" scope="col" style="width:10%;">{{ $t('pdr.part2.Achievement')}}</th>
                                                                <th class="text-left col-elem border-elem" scope="col" style="width: 20%;">{{ $t('pdr.part2.comments')}}</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="objective in employeeData.reviewFirstPart.objectivesEmployee" v-bind:key="objective.id">
                                                                <td class="text-left border-elem-in-table pt-2 pb-2">{{ objective.id }}</td>
                                                                <td class="text-left border-elem-in-table pt-2 pb-2">{{ objective.name }}</td>
                                                                <td class="text-left border-elem-in-table pt-2 pb-2">{{ objective.description }}</td>
                                                                <td class="text-left border-elem-in-table pt-2 pb-2">{{ objective.successIndicator }}</td>
                                                                <td class="text-left border-elem-in-table pt-2 pb-2">{{ objective.completionDate | simpleDate }}</td>
                                                                <td class="text-left border-elem-in-table pt-2 pb-2">{{ objective.weighting }} %</td>
                                                                <td class="text-left border-elem-in-table pt-2 pb-2">
                                                                    <div class="mt-3 mb-3 " v-if="submitedPartOneAndTwo || userCanReadBool">{{ objective.slManagerAchievements }} %</div>
                                                                    <v-text-field required :rules="SLAchievementRules" v-else class="mt-3 mb-3 " @change="calculateTotalWeightPart1()" @keypress="isNumber($event)" v-model="objective.slManagerAchievements" type="number" step="5" min="0" max="100" hide-details suffix="%" outlined></v-text-field>
                                                                </td>
                                                                <td class="text-left border-elem-in-table pt-2 pb-2">
                                                                    <div class="mt-3 mb-3" v-if="submitedPartOneAndTwo || userCanReadBool">{{ objective.slManagerComments }}</div>
                                                                    <v-textarea maxlength="800" v-else class="mt-3 mb-3"  required :rules="SLCommentRules" v-model="objective.slManagerComments" outlined hide-details auto-grow row-height="2">
                                                                        <template v-slot:label>{{
                                                                        $t("pdr.part2.SlManagerComment")
                                                                        }}</template>
                                                                    </v-textarea>
                                                                </td>
                                                            </tr>

                                                            <!-- FOOTER -->
                                                            <tr class="general-background">
                                                                <th class="text-left border-elem" colspan="6">{{$t('pdr.part2.GlobalAchievement')}}</th>
                                                                <th class="text-left border-elem" colspan="2" v-if="GlobalAchivementRatePart1Manager <= 100">{{ GlobalAchivementRatePart1Manager }} %</th>
                                                                <th class="text-left border-elem" style="background-color: #B71C1C !important;" v-else colspan="2">{{ GlobalAchivementRatePart1Manager }} %</th>
                                                            </tr>
                                                        </tbody>
                                                    </template>
                                                </v-simple-table>
                                            </template>

                                            <!-- Tableau Employee Self Assessment  -->
                                            <template>
                                                <v-simple-table class="margin-top">
                                                    <template v-slot:default>
                                                        <thead>
                                                            <tr class="second-background">
                                                                <td class="text-center col-elem border-elem" rowspan="2">{{ $t('pdr.part2.n')}}</td>
                                                                <th class="text-left col-elem border-elem" colspan="2" scope="colgroup">{{$t('pdr.part2.EmployeeSelf')}}</th>
                                                            </tr>
                                                            <tr class="second-background">
                                                                <th class="text-left col-elem border-elem" scope="col" style="width: 120px;">{{$t('pdr.part2.Achievement')}}</th>
                                                                <th class="text-left col-elem border-elem" scope="col" style="width: 90%;">{{$t('pdr.part2.comments')}}</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="objective in employeeData.reviewFirstPart.objectivesEmployee" v-bind:key="objective.id">
                                                                <td class="text-left border-elem-in-table  pt-2 pb-2">{{ objective.id }}</td>
                                                                <td class="text-center border-elem-in-table pt-2 pb-2">{{ objective.employeeAchievements }}%</td>
                                                                <td class="text-left border-elem-in-table pt-2 pb-2">{{ objective.employeeComments }}</td>
                                                            </tr>
                                                        </tbody>
                                                    </template>
                                                </v-simple-table>
                                            </template>
                                        </v-card-text>
                                    </v-card>
                                    <br>
                                    <!-- ASSESSING PERFORMANCE CONTENT CARD  -->
                                    <v-card flat>
                                        <v-card-title class="secondary-titles" id="step_22" @click="$vuetify.goTo('#step_22', options)">
                                            <v-icon color="#8ba79d" class="mr-2">mdi-numeric-2-circle</v-icon> {{$t('pdr.part2.AssessingPerformance')}}
                                        </v-card-title>
                                        <v-card-text class=" ml-5">
                                            <v-alert class="mr-3 info-text margin-top" border="left" colored-border color="#8ba79d" type="info" elevation="4">
                                                <v-card-text v-html="labels['ASS_PERF_'+locale.toUpperCase()]"> </v-card-text>
                                            </v-alert>
                                            <template>
                                                <v-simple-table style="overflow:hidden; margin-top: 25px;">
                                                    <template v-slot:default>
                                                        <thead>
                                                            <tr class="second-table-general-header">
                                                                <th class="text-left col-elem" colspan="3" id="skills" @click="$vuetify.goTo('#skills', options)" style="cursor: pointer"><b>{{$t('pdr.part2.Skills')}}</b></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <!-- TECHNICAL SKILLS -->
                                                            <tr class="second-table-specific-header">
                                                                <th class="text-left col-elem-specific-header" colspan="3" id="technical_skills" @click="$vuetify.goTo('#technical_skills', options)" style="cursor: pointer"><b>{{$t('pdr.part2.TechnicalSkills')}}</b></th>
                                                            </tr>
                                                            <tr class="no-hover-row">
                                                                <td class="text-left border-elem" rowspan="2" style="width: 50%">{{$t('pdr.part2.Assess')}}</td>

                                                                <td class="border-elem-in-table" style="background-color: #f0f0f0; width: 25%">
                                                                    {{ selectedTechnicalSkill }}
                                                                </td>

                                                                <td class="border-elem-in-table">
                                                                    <div class="mt-3 mb-3" v-if="submitedPartOneAndTwo || userCanReadBool">{{ selectedTechnicalSkillManager }}</div>
                                                                    <v-select v-else class="mt-3 mb-3"  required :rules="TechnicalSkillRules" v-model="selectedTechnicalSkillManager" :items="filterSkills(technicalSkillsItems)" dense hide-details outlined>
                                                                        <template v-slot:label>{{
                                                                        $t("pdr.part2.SelectTechnicalSkill")
                                                                        }}</template>
                                                                        <template slot="selection" slot-scope="data">
                                                                            {{ data.item.value }}
                                                                        </template>
                                                                        <template slot="item" slot-scope="data">
                                                                            {{ data.item.value }}
                                                                        </template>
                                                                    </v-select>
                                                                </td>
                                                            </tr>
                                                            <tr class="no-hover-row">
                                                                <td class="text-left border-elem-in-table" style="background-color: #f0f0f0">
                                                                    {{ employeeData.reviewFirstPart.assessingEmployeeDto.technicalSkillsComment }}
                                                                </td>

                                                                <td class="text-left border-elem-in-table">
                                                                    <div class="mt-3 mb-3" v-if="submitedPartOneAndTwo  && userCanReadBool">{{ employeeData.reviewFirstPart.assessingManagerDto.technicalSkillsComment }}</div>
                                                                    <v-textarea maxlength="800" required :rules="TechnicalSkillCommentRules" v-else v-model="employeeData.reviewFirstPart.assessingManagerDto.technicalSkillsComment" class="mt-3 mb-3" outlined auto-grow hide-details>
                                                                        <template v-slot:label>{{
                                                                        $t("pdr.part2.SlManagerComment")
                                                                        }}</template>
                                                                    </v-textarea>
                                                                </td>
                                                            </tr>

                                                            <!-- CULTURE AND VALUES -->
                                                            <tr class="second-table-specific-header">
                                                                <th class="text-left col-elem-specific-header" id="culture_values" @click="$vuetify.goTo('#culture_values', options)" colspan="3" style="cursor: pointer"><b>{{$t('pdr.part2.Culture')}}</b></th>
                                                            </tr>

                                                            <!-- First -->
                                                            <tr class="no-hover-row">
                                                                <td class="text-left border-elem" rowspan="2">
                                                                    <p class="mt-2">
                                                                        <b>{{$t('pdr.part2.Value1')}}</b> <br> <br>
                                                                        <ul>
                                                                            <li>{{$t('pdr.part2.Value1Part1')}}</li>
                                                                            <li>{{$t('pdr.part2.Value1Part2')}}</li>
                                                                        </ul>
                                                                    </p>

                                                                </td>

                                                                <td class="border-elem-in-table" style="background-color: #f0f0f0">
                                                                    {{ selectedCustomerCentric }}
                                                                </td>

                                                                <td class="border-elem-in-table">
                                                                    <div class="mt-3 mb-3" v-if="submitedPartOneAndTwo || userCanReadBool">{{ selectedCustomerCentricManager }}</div>
                                                                    <v-select v-else required :rules="FisrtRules"  class="mt-3 mb-3" v-model="selectedCustomerCentricManager" :items="filterSkills(cultureAndValuesItems)" dense hide-details outlined>
                                                                        <template v-slot:label>{{
                                                                        $t("pdr.part2.SelectCulture")
                                                                        }}</template>
                                                                        <template slot="selection" slot-scope="data">
                                                                            {{ data.item.value }}
                                                                        </template>
                                                                        <template slot="item" slot-scope="data">
                                                                            {{ data.item.value }}
                                                                        </template>
                                                                    </v-select>
                                                                </td>
                                                            </tr>

                                                            <tr class="no-hover-row">

                                                                <td class="text-left border-elem-in-table" style="background-color: #f0f0f0">
                                                                    {{ employeeData.reviewFirstPart.assessingEmployeeDto.customerCentricComment }}
                                                                </td>

                                                                <td class="text-left border-elem-in-table">
                                                                    <div class="mt-3 mb-3" v-if="submitedPartOneAndTwo || userCanReadBool">{{ employeeData.reviewFirstPart.assessingManagerDto.customerCentricComment }}</div>
                                                                    <v-textarea maxlength="800" v-else required :rules="FisrtCommentRules"  v-model="employeeData.reviewFirstPart.assessingManagerDto.customerCentricComment" class="mt-3 mb-3" outlined auto-grow hide-details>
                                                                        <template v-slot:label>{{
                                                                        $t("pdr.part2.SlManagerComment")
                                                                        }}</template>
                                                                    </v-textarea>
                                                                </td>
                                                            </tr>
                                                            <div></div>
                                                            <!-- Second -->
                                                            <tr class="no-hover-row">
                                                                <td class="text-left border-elem" rowspan="2">
                                                                    <p class="mt-2">
                                                                        <b>{{$t('pdr.part2.Value2')}}</b> <br> <br>
                                                                        <ul>
                                                                            <li>{{$t('pdr.part2.Value2Part1')}}</li>
                                                                            <li>{{$t('pdr.part2.Value2Part2')}}</li>
                                                                        </ul>
                                                                    </p>

                                                                </td>

                                                                <td class="border-elem-in-table" style="background-color: #f0f0f0">
                                                                    {{ selectedFeelingvalued }}
                                                                </td>

                                                                <td class="border-elem-in-table">
                                                                    <div class="mt-3 mb-3" v-if="submitedPartOneAndTwo || userCanReadBool">{{ selectedFeelingvaluedManager }}</div>
                                                                    <v-select v-else required :rules="SecondRules"  class="mt-3 mb-3" v-model="selectedFeelingvaluedManager" :items="filterSkills(cultureAndValuesItems)" dense hide-details outlined>
                                                                        <template v-slot:label>{{
                                                                        $t("pdr.part2.SelectCulture")
                                                                        }}</template>
                                                                        <template slot="selection" slot-scope="data">
                                                                            {{ data.item.value }}
                                                                        </template>
                                                                        <template slot="item" slot-scope="data">
                                                                            {{ data.item.value }}
                                                                        </template>
                                                                    </v-select>
                                                                </td>
                                                            </tr>

                                                            <tr class="no-hover-row">
                                                                <td class="border-elem-in-table" style="background-color: #f0f0f0">
                                                                    {{ employeeData.reviewFirstPart.assessingEmployeeDto.feelingValuedComment }}
                                                                </td>

                                                                <td class="text-left border-elem-in-table">
                                                                    <div class="mt-3 mb-3" v-if="submitedPartOneAndTwo || userCanReadBool">{{ employeeData.reviewFirstPart.assessingManagerDto.feelingValuedComment }}</div>
                                                                    <v-textarea maxlength="800" v-else required :rules="SecondCommentRules"  v-model="employeeData.reviewFirstPart.assessingManagerDto.feelingValuedComment" class="mt-3 mb-3" outlined auto-grow hide-details>
                                                                        <template v-slot:label>{{
                                                                        $t("pdr.part2.SlManagerComment")
                                                                        }}</template>
                                                                    </v-textarea>
                                                                </td>
                                                            </tr>

                                                            <div></div>
                                                            <!-- Third -->
                                                            <tr class="no-hover-row">
                                                                <td class="text-left border-elem" rowspan="2">
                                                                    <p class="mt-2">
                                                                        <b>{{$t('pdr.part2.Value3')}}</b> <br> <br>
                                                                        <ul>
                                                                            <li>{{$t('pdr.part2.Value3Part1')}}</li>
                                                                            <li>{{$t('pdr.part2.Value3Part2')}}</li>
                                                                        </ul>
                                                                    </p>

                                                                </td>

                                                                <td class="border-elem-in-table" style="background-color: #f0f0f0">
                                                                    {{ selectedOpenCommunication }}
                                                                </td>

                                                                <td class="border-elem-in-table">
                                                                    <div class="mt-3 mb-3" v-if="submitedPartOneAndTwo || userCanReadBool">{{ selectedOpenCommunicationManager }}</div>
                                                                    <v-select v-else required :rules="ThirdRules"  class="mt-3 mb-3" v-model="selectedOpenCommunicationManager" :items="filterSkills(cultureAndValuesItems)" dense hide-details outlined>
                                                                        <template v-slot:label>{{
                                                                        $t("pdr.part2.SelectCulture")
                                                                        }}</template>
                                                                        <template slot="selection" slot-scope="data">
                                                                            {{ data.item.value }}
                                                                        </template>
                                                                        <template slot="item" slot-scope="data">
                                                                            {{ data.item.value }}
                                                                        </template>
                                                                    </v-select>
                                                                </td>
                                                            </tr>

                                                            <tr class="no-hover-row">

                                                                <td class="border-elem-in-table" style="background-color: #f0f0f0">
                                                                    {{ employeeData.reviewFirstPart.assessingEmployeeDto.openCommunicationComment }}
                                                                </td>

                                                                <td class="text-left border-elem-in-table">
                                                                    <div class="mt-3 mb-3" v-if="submitedPartOneAndTwo || userCanReadBool">{{ employeeData.reviewFirstPart.assessingManagerDto.openCommunicationComment }}</div>
                                                                    <v-textarea maxlength="800" v-else required :rules="ThirdCommentRules"  v-model="employeeData.reviewFirstPart.assessingManagerDto.openCommunicationComment" class="mt-3 mb-3" outlined auto-grow hide-details>
                                                                        <template v-slot:label>{{
                                                                        $t("pdr.part2.SlManagerComment")
                                                                        }}</template>
                                                                    </v-textarea>
                                                                </td>
                                                            </tr>

                                                            <div></div>
                                                            <!-- Fourth -->
                                                            <tr class="no-hover-row">
                                                                <td class="text-left border-elem" rowspan="2">
                                                                    <p class="mt-2">
                                                                        <b>{{$t('pdr.part2.Value4')}}</b> <br> <br>
                                                                        <ul>
                                                                            <li>{{$t('pdr.part2.Value4Part1')}}</li>
                                                                            <li>{{$t('pdr.part2.Value4Part2')}}</li>
                                                                        </ul>
                                                                    </p>

                                                                </td>

                                                                <td class="border-elem-in-table" style="background-color: #f0f0f0">
                                                                    {{ selectedWorkingTogether }}
                                                                </td>

                                                                <td class="border-elem-in-table">
                                                                    <div class="mt-3 mb-3" v-if="submitedPartOneAndTwo || userCanReadBool">{{ selectedWorkingTogetherManager }}</div>
                                                                    <v-select v-else required :rules="FourthRules"  class="mt-3 mb-3" v-model="selectedWorkingTogetherManager" :items="filterSkills(cultureAndValuesItems)" dense hide-details outlined>
                                                                        <template v-slot:label>{{
                                                                        $t("pdr.part2.SelectCulture")
                                                                        }}</template>
                                                                        <template slot="selection" slot-scope="data">
                                                                            {{ data.item.value }}
                                                                        </template>
                                                                        <template slot="item" slot-scope="data">
                                                                            {{ data.item.value }}
                                                                        </template>
                                                                    </v-select>
                                                                </td>
                                                            </tr>

                                                            <tr class="no-hover-row">

                                                                <td class="border-elem-in-table" style="background-color: #f0f0f0">
                                                                    {{ employeeData.reviewFirstPart.assessingEmployeeDto.workingTogetherComment }}
                                                                </td>

                                                                <td class="text-left border-elem-in-table">
                                                                    <div class="mt-3 mb-3" v-if="submitedPartOneAndTwo || userCanReadBool">{{ employeeData.reviewFirstPart.assessingManagerDto.workingTogetherComment }}</div>
                                                                    <v-textarea maxlength="800" v-else required :rules="FourthCommentRules" v-model="employeeData.reviewFirstPart.assessingManagerDto.workingTogetherComment" class="mt-3 mb-3" outlined auto-grow hide-details>
                                                                        <template v-slot:label>{{
                                                                        $t("pdr.part2.SlManagerComment")
                                                                        }}</template>
                                                                    </v-textarea>
                                                                </td>
                                                            </tr>

                                                            <!-- LEADERSHIP -->
                                                            <tr class="second-table-specific-header">
                                                                <th class="text-left col-elem-specific-header" id="leadership" @click="$vuetify.goTo('#leadership', options)" colspan="3" style="cursor: pointer"><b>{{$t('pdr.part2.Leadership')}}</b></th>
                                                            </tr>

                                                            <tr class="no-hover-row">
                                                                <td class="text-left border-elem" rowspan="2">
                                                                    <p class="mt-2">
                                                                        <ul>
                                                                            <li>{{$t('pdr.part2.Engageandinspire')}}</li>
                                                                            <li>{{$t('pdr.part2.Provideandcommunicat')}}</li>
                                                                            <li>{{$t('pdr.part2.Seetheglobal')}}</li>
                                                                            <li>{{$t('pdr.part2.Takesinitiative')}}</li>
                                                                            <li>{{$t('pdr.part2.Supportandstimulate')}}</li>
                                                                            <li>{{$t('pdr.part2.Leadthetransformation')}}</li>
                                                                        </ul>
                                                                    </p>

                                                                </td>

                                                                <td class="border-elem-in-table" style="background-color: #f0f0f0">
                                                                    {{ selectedLeadership }}
                                                                </td>

                                                                <td class="border-elem-in-table">
                                                                    <div class="mt-3 mb-3" v-if="submitedPartOneAndTwo || userCanReadBool">{{ selectedLeadershipManager }}</div>
                                                                    <v-select required :rules="LeadershipRules" v-else class="mt-3 mb-3" v-model="selectedLeadershipManager" :items="filterSkills(leadershipItems)" dense  hide-details outlined>
                                                                        <template v-slot:label>{{
                                                                        $t("pdr.part2.SelectLeadershiplevel")
                                                                        }}</template>
                                                                        <template slot="selection" slot-scope="data">
                                                                            {{ data.item.value }}
                                                                        </template>
                                                                        <template slot="item" slot-scope="data">
                                                                            {{ data.item.value }}
                                                                        </template>
                                                                    </v-select>
                                                                </td>
                                                            </tr>

                                                            <tr class="no-hover-row">

                                                                <td class="border-elem-in-table" style="background-color: #f0f0f0">
                                                                    {{ employeeData.reviewFirstPart.assessingEmployeeDto.leadershipComment }}
                                                                </td>

                                                                <td class="text-left border-elem-in-table">
                                                                    <div class="mt-3 mb-3" v-if="submitedPartOneAndTwo || userCanReadBool">{{ employeeData.reviewFirstPart.assessingManagerDto.leadershipComment }}</div>
                                                                    <v-textarea maxlength="800" v-else required :rules="LeadershipCommentRules"  v-model="employeeData.reviewFirstPart.assessingManagerDto.leadershipComment" class="mt-3 mb-3" outlined auto-grow hide-details>
                                                                        <template v-slot:label>{{
                                                                        $t("pdr.part2.SlManagerComment")
                                                                        }}</template>
                                                                    </v-textarea>
                                                                </td>
                                                            </tr>

                                                            <!-- EXECUTION EXCELLENCE -->
                                                            <tr class="second-table-specific-header">
                                                                <th class="text-left col-elem-specific-header" id="execution_excellence" @click="$vuetify.goTo('#execution_excellence', options)" colspan="3" style="cursor: pointer"><b>{{$t('pdr.part2.ExecutionExcellence')}}</b></th>
                                                            </tr>

                                                            <tr class="no-hover-row">
                                                                <td class="text-left border-elem" rowspan="2">
                                                                    <p class="mt-2">
                                                                        <ul>
                                                                            <li>{{$t('pdr.part2.Setchallengingobjectives')}}</li>
                                                                            <li>{{$t('pdr.part2.Continuallystrives')}}</li>
                                                                        </ul>
                                                                    </p>

                                                                </td>

                                                                <td class="border-elem" style="background-color: #f0f0f0">
                                                                    {{ selectedExectionExcellence }}
                                                                </td>

                                                                <td class="border-elem-in-table">
                                                                    <div class="mt-3 mb-3" v-if="submitedPartOneAndTwo || userCanReadBool">{{ selectedExectionExcellenceManager }}</div>
                                                                    <v-select v-else required :rules="ExecutionRules"  class="mt-3 mb-3" v-model="selectedExectionExcellenceManager" :items="filterSkills(cultureAndValuesItems)" dense hide-details outlined>
                                                                        <template v-slot:label>{{
                                                                        $t("pdr.part2.SelectExecutionlevel")
                                                                        }}</template>
                                                                        <template slot="selection" slot-scope="data">
                                                                            {{ data.item.value }}
                                                                        </template>
                                                                        <template slot="item" slot-scope="data">
                                                                            {{ data.item.value }}
                                                                        </template>
                                                                    </v-select>
                                                                </td>
                                                            </tr>

                                                            <tr class="no-hover-row">

                                                                <td class="border-elem-in-table" style="background-color: #f0f0f0">
                                                                    {{ employeeData.reviewFirstPart.assessingEmployeeDto.executionExcellence }}
                                                                </td>

                                                                <td class="text-left border-elem-in-table">
                                                                    <div class="mt-3 mb-3" v-if="submitedPartOneAndTwo || userCanReadBool">{{ employeeData.reviewFirstPart.assessingManagerDto.executionExcellence }}</div>
                                                                    <v-textarea maxlength="800" v-else required :rules="ExecutionCommentRules" v-model="employeeData.reviewFirstPart.assessingManagerDto.executionExcellence" class="mt-3 mb-3" outlined auto-grow hide-details>
                                                                        <template v-slot:label>{{
                                                                        $t("pdr.part2.SlManagerComment")
                                                                        }}</template>
                                                                    </v-textarea>
                                                                </td>
                                                            </tr>

                                                            <!-- OVERALL PERFORMANCE -->
                                                            <tr class="second-table-general-header">
                                                                <th class="text-left col-elem" colspan="3" id="overall_performance" @click="$vuetify.goTo('#overall_performance', options)" style="cursor: pointer"><b>{{$t('pdr.part2.OverallPerformance')}}</b></th>
                                                            </tr>
                                                            <tr class="no-hover-row">
                                                                <td class="text-left border-elem" rowspan="2">
                                                                    {{$t('pdr.part2.Pleaseratetheoverall')}}
                                                                </td>

                                                                <td class="border-elem-in-table" style="background-color: #f0f0f0">
                                                                    {{ selectedOverallPerformance }}
                                                                </td>

                                                                <td class="border-elem-in-table">
                                                                    <div class="mt-3 mb-3" v-if="submitedPartOneAndTwo || userCanReadBool">{{ selectedOverallPerformanceManager }}</div>
                                                                    <v-select v-else required :rules="OverallPerformanceRules" class="mt-3 mb-3" v-model="selectedOverallPerformanceManager" :items="filterSkills(overallPerformanceItems)" dense  hide-details outlined>
                                                                        <template v-slot:label>{{
                                                                        $t("pdr.part2.SelectOverallPerformancelevel")
                                                                        }}</template>
                                                                        <template slot="selection" slot-scope="data">
                                                                            {{ data.item.value }}
                                                                        </template>
                                                                        <template slot="item" slot-scope="data">
                                                                            {{ data.item.value }}
                                                                        </template>
                                                                    </v-select>
                                                                </td>
                                                            </tr>

                                                            <tr class="no-hover-row">

                                                                <td class="border-elem-in-table" style="background-color: #f0f0f0">
                                                                    {{ employeeData.reviewFirstPart.assessingEmployeeDto.overallPerformanceComment }}
                                                                </td>

                                                                <td class="text-left border-elem-in-table">
                                                                    <div class="mt-3 mb-3" v-if="submitedPartOneAndTwo || userCanReadBool">{{ employeeData.reviewFirstPart.assessingManagerDto.overallPerformanceComment }}</div>
                                                                    <v-textarea maxlength="800" v-else required :rules="OverallPerformanceCommentRules"  class="mt-3 mb-3" v-model="employeeData.reviewFirstPart.assessingManagerDto.overallPerformanceComment" outlined auto-grow hide-details>
                                                                        <template v-slot:label>{{
                                                                        $t("pdr.part2.SlManagerComment")
                                                                        }}</template>
                                                                    </v-textarea>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </template>
                                                </v-simple-table>
                                            </template>
                                        </v-card-text>
                                    </v-card>
                                    <!-- NOTIFICATION PDR -->
                                    <v-card flat>
                                        <v-card-title class="secondary-titles" id="step_23" @click="$vuetify.goTo('#step_23', options)">
                                            {{$t('pdr.part2.NotificationPDR')}}
                                        </v-card-title>
                                        <v-card-text>
                                            <v-alert class="mr-3 info-text margin-top" border="left" colored-border color="#8ba79d" type="info" elevation="4">
                                                {{$t('pdr.part2.Thissection')}} 
                                            </v-alert>

                                            <template>
                                                <v-simple-table style="margin-top: 25px;">
                                                    <template v-slot:default>
                                                        <thead>
                                                            <tr>
                                                                <th class="text-left col-elem border-elem"><b></b></th>
                                                                <th class="text-left col-elem border-elem general-background"><b>{{$t('pdr.part2.Task')}}</b></th>
                                                                <th class="text-center col-elem border-elem general-background" style="width: 5%"><b>{{$t('pdr.part2.Signature')}}</b></th>
                                                                <th class="text-left col-elem border-elem general-background"><b>{{$t('pdr.part2.Date')}}</b></th>
                                                                <th class="text-left col-elem border-elem general-background" style="width: 50%;"><b>{{$t('pdr.part2.Commentsshared')}}</b></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td class="text-left border-elem general-background">{{$t('pdr.reference.slmanager')}}</td>
                                                                <td class="text-left border-elem-in-table">{{$t('pdr.part2.PDRformvalidation')}}</td>
                                                                <td class="text-center border-elem-in-table">
                                                                    <v-icon v-if="employeeData.reviewFirstPart.slmanagerSigned" color="success">mdi-check-bold</v-icon>
                                                                    <v-icon v-else>mdi-clock-outline</v-icon>
                                                                </td>
                                                                <td class="text-left border-elem-in-table">{{ employeeData.reviewFirstPart.slmanagerDate | simpleDate }}</td>
                                                                <td class="text-left border-elem-in-table">
                                                                    <div v-if="submitedPartOneAndTwo || userCanReadBool"> {{ employeeData.reviewFirstPart.slmanagerComment }} </div>
                                                                    <v-textarea maxlength="1800" v-else required :rules="PDRSLRules"  v-model="employeeData.reviewFirstPart.slmanagerComment" class="mt-3 mb-3" outlined hide-details auto-grow row-height="2">
                                                                        <template v-slot:label>{{
                                                                        $t("pdr.part2.SlManagerComment")
                                                                        }}</template>
                                                                    </v-textarea>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td class="text-left border-elem general-background">{{$t('pdr.reference.dlmanager')}}</td>
                                                                <td class="text-left border-elem-in-table">{{$t('pdr.part2.PDRformvalidation')}}</td>
                                                                <td class="text-center border-elem-in-table">
                                                                    <v-icon v-if="employeeData.reviewFirstPart.dlmanagerSigned" color="success">mdi-check-bold</v-icon>
                                                                    <v-icon v-else>mdi-clock-outline</v-icon>
                                                                </td>
                                                                <td class="text-left border-elem-in-table">{{ employeeData.reviewFirstPart.dlmanagerDate | simpleDate }}</td>
                                                                <td class="text-left border-elem-in-table"> {{ employeeData.reviewFirstPart.dlmanagerComment }} </td>
                                                            </tr>
                                                            <tr>
                                                                <td class="text-left border-elem general-background">{{$t('pdr.reference.employee')}}</td>
                                                                <td class="text-left border-elem-in-table">{{$t('pdr.part2.PDRformvalidation')}}</td>
                                                                <td class="text-center border-elem-in-table">
                                                                    <v-icon v-if="employeeData.reviewFirstPart.employeeSigned" color="success">mdi-check-bold</v-icon>
                                                                    <v-icon v-else>mdi-clock-outline</v-icon>
                                                                </td>
                                                                <td class="text-left border-elem-in-table">{{ employeeData.reviewFirstPart.employeeDate | simpleDate }}</td>
                                                                <td class="text-left border-elem-in-table"> {{ employeeData.reviewFirstPart.employeeComment }} </td>
                                                            </tr>
                                                            <tr>
                                                                <td class="text-left border-elem general-background">{{$t('pdr.part2.PDRformvalidation')}}</td>
                                                                <td v-if="!submitedPartOneAndTwo || userCanReadBool" colspan="4">
                                                                    <v-menu :close-on-content-click="true" :nudge-right="100" :nudge-top="3" transition="scale-transition" offset-y>
                                                                        <template v-slot:activator="{ on }">
                                                                            <v-text-field class="mt-3 mb-3" readonly required :rules="DateRules" append-icon="mdi-calendar-today" hide-details outlined v-model="employeeData.reviewFirstPart.dateInterview" v-on="on">
                                                                                <template v-slot:label>{{
                                                                        $t("pdr.part2.Dateofinterview")
                                                                        }}</template>
                                                                            </v-text-field>
                                                                        </template>
                                                                        <v-date-picker landscape v-model="employeeData.reviewFirstPart.dateInterview" color="#00635b" locale="fr-fr"></v-date-picker>
                                                                    </v-menu>
                                                                </td>
                                                                <td v-else colspan="4"> {{ employeeData.reviewFirstPart.dateInterview | simpleDate }}</td>
                                                            </tr>
                                                        </tbody>
                                                    </template>
                                                </v-simple-table>
                                            </template>
                                        </v-card-text>
                                    </v-card>
                                </v-card>

                                <v-btn v-if="!statusIsEmployeeProposalPart3_4" class="ml-2 mb-3" color="#00635b" style="color: white !important;" @click="genralStepperIndex = 3">{{$t('pdr.part2.NEXT')}} <v-icon>mdi-arrow-down</v-icon>
                                </v-btn>
                                <v-btn class=" ml-2 mb-3" color="grey lighten-3" @click="genralStepperIndex = 1">{{$t('pdr.part2.PREVIOUS')}} <v-icon>mdi-arrow-up</v-icon>
                                </v-btn>
                                <br>
                                <v-btn v-if="!submitedPartOneAndTwo || userCanReadBool" class=" ml-2 mb-3" color="success" @click="savePartOneAndTwo">{{$t('pdr.part2.SAVEPART12')}}</v-btn>
                                <v-btn v-if="!submitedPartOneAndTwo || userCanReadBool" class=" ml-2 mb-3" color="red" style="color: white !important;" @click="submitPartOneAndTwo">{{$t('pdr.part2.SUBMITPART12')}}</v-btn>

                                <!-- SNACKBAR Part 1 - 2 -->
                                <v-snackbar v-model="snackbar" :color="snackBarColor" :timeout="snackBarTimeout">
                                    <b>{{ snackBarText }} </b>
                                </v-snackbar>
                            </v-stepper-content>
                        </div>
                    </v-form>

                    <!-- STEPPER 3 -->
                    <v-stepper-step v-if="!statusIsEmployeeProposalPart3_4" editable step="3" color="#00635b" id="step_3" @click="$vuetify.goTo('#step_3', options)"><b>{{$t('pdr.part3.title')}}</b> </v-stepper-step>
                    <!-- CONTENT OF STEPPER 3 -->
                    <v-stepper-content step="3">
                        <v-form ref="formPart2" v-model="validPart2" :lazy-validation="lazyPart2">
                            <v-card color="grey lighten-5" class="mb-12">
                                <v-alert class="mr-3 info-text " colored-border border="left" color="#00635b" type="info" elevation="4">
                                    <v-card-text v-html="labels['PDR_PROCESS_'+locale.toUpperCase()]"> </v-card-text>
                                </v-alert>

                                <!--  OBJECTIVE SETTING  -->
                                <v-card flat>
                                    <v-card-title class="secondary-titles" id="step_31" @click="$vuetify.goTo('#step_31', options)">
                                        <v-icon color="#8ba79d" class="mr-2">mdi-numeric-3-circle</v-icon> {{$t('pdr.part3.Objectivessettings')}}
                                    </v-card-title>
                                    <v-card-text class="ml-5">
                                        <v-alert class="mr-3 mb-5 info-text margin-top" border="left" colored-border color="#8ba79d" type="info" elevation="4">
                                            <v-card-text v-html="labels['OBJ_SETTINGS_'+locale.toUpperCase()]"> </v-card-text>
                                        </v-alert>

                                        <v-row justify="center">
                                            <v-btn rounded style="color: white; background-color:#00b0c7;" class="mb-10" @click="showHideObjectivesEMployee()">
                                                <span v-if="!showEmployeeProposal">{{$t('pdr.part3.Show')}}</span> <span v-else>{{$t('pdr.part3.Hide')}}</span>&nbsp;{{$t('pdr.part3.EmployeeProposal')}}
                                            </v-btn>
                                        </v-row>

                                        <div v-if="showEmployeeProposal" class="mb-10">
                                            <h5><b style="color: #8ba79d;">{{$t('pdr.part3.EmployeeProposal')}}</b></h5>
                                            <template>
                                                <v-simple-table style="margin-top: 15px;">
                                                    <template v-slot:default>
                                                        <thead>
                                                            <tr class="second-background">
                                                                <th class="text-left col-elem border-elem"><b>{{ $t('pdr.part2.ObjectiveName')}}</b></th>
                                                                <th class="text-left col-elem border-elem" style="width: 40%;"><b>{{ $t('pdr.part2.Description')}}</b></th>
                                                                <th class="text-left col-elem border-elem"><b>{{ $t('pdr.part2.Indicator')}}</b></th>
                                                                <th class="text-left col-elem border-elem" style="width: 200px;"><b>{{ $t('pdr.part2.Completion')}}</b></th>
                                                                <th class="text-left col-elem border-elem" style="width:10%;"><b>{{ $t('pdr.part2.poids')}}</b></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="objective in employeeData.reviewSecondPart.objectivesEmployee" v-bind:key="objective.id">
                                                                <td class="text-left border-elem-in-table">
                                                                    <div class="mt-3 mb-3 ">{{ objective.name }}</div>
                                                                </td>
                                                                <td class="text-left border-elem-in-table">
                                                                    <div class="mt-3 mb-3 ">{{ objective.description }}</div>
                                                                </td>
                                                                <td class="text-left border-elem-in-table">
                                                                    <div class="mt-3 mb-3 ">{{ objective.successIndicator }}</div>
                                                                </td>
                                                                <td class="text-left border-elem-in-table">
                                                                    <div class="mt-3 mb-3 "> {{ objective.completionDate }}</div>

                                                                </td>
                                                                <td class="text-left border-elem-in-table">
                                                                    <div class="mt-3 mb-3 ">{{ objective.weighting }}</div>
                                                                </td>
                                                            </tr>
                                                            <!-- FOOTER -->
                                                            <tr class="second-background">
                                                                <th class="text-right border-elem" style="color: white" colspan="4">{{$t('pdr.part3.TotalWeight')}}</th>
                                                                <th class="text-left border-elem-in-table" style="color: white" colspan="2">{{ GlobalAchivementRatePart2Employee }} %</th>
                                                            </tr>
                                                        </tbody>
                                                    </template>
                                                </v-simple-table>
                                            </template>
                                        </div>

                                        <h5><b style="color: #8ba79d;">{{$t('pdr.part3.SLManagerProposal')}}</b></h5>

                                        <template>
                                            <v-simple-table style="margin-top: 15px;">
                                                <template v-slot:default>
                                                    <thead>
                                                        <tr class="general-background">
                                                            <th class="text-left col-elem border-elem"><b>{{$t('pdr.part2.ObjectiveName')}}</b></th>
                                                            <th class="text-left col-elem border-elem" style="width: 40%;"><b>{{$t('pdr.part2.Description')}}</b></th>
                                                            <th class="text-left col-elem border-elem"><b>{{$t('pdr.part2.Indicator')}}</b></th>
                                                            <th class="text-left col-elem border-elem" style="width: 200px;"><b>{{$t('pdr.part2.Completion')}}</b></th>
                                                            <th class="text-left col-elem border-elem" style="width: 120px;"><b>{{$t('pdr.part2.poids')}}</b></th>
                                                            <th v-if="!submitedPartThreeAndFour || userCanReadBool" class="text-center col-elem border-elem" style="width: 100px;"><b>{{ $t('pdr.part2.Action')}}</b></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="objective in employeeData.reviewSecondPart.objectivesManager" v-bind:key="objective.id">
                                                            <td class="text-left border-elem-in-table pt-2 pb-2">
                                                                <div class="mt-3 mb-3 " v-if="submitedPartThreeAndFour || userCanReadBool">{{ objective.name }}</div>
                                                                <v-text-field maxlength="190" v-else required :rules="ObjectifNamePart2Rules"  v-model="objective.name" class="mt-3 mb-3 " hide-details outlined>
                                                                    <template v-slot:label>{{
                                                                        $t("pdr.part2.ObjectiveName")
                                                                        }}</template>
                                                                </v-text-field>
                                                            </td>
                                                            <td class="text-left border-elem-in-table pt-2 pb-2">
                                                                <div class="mt-3 mb-3 " v-if="submitedPartThreeAndFour || userCanReadBool">{{ objective.description }}</div>
                                                                <v-textarea maxlength="1000" v-else required :rules="ObjectifDescriptionPart2Rules"  v-model="objective.description" class="mt-3 mb-3" outlined hide-details auto-grow row-height="2">
                                                                    <template v-slot:label>{{
                                                                        $t("pdr.part2.Description")
                                                                        }}</template>
                                                                </v-textarea>
                                                            </td>
                                                            <td class="text-left border-elem-in-table pt-2 pb-2">
                                                                <div class="mt-3 mb-3 " v-if="submitedPartThreeAndFour || userCanReadBool">{{ objective.successIndicator }}</div>
                                                                <v-textarea maxlength="1000" v-else required :rules="ObjectifInidicatorPart2Rules" v-model="objective.successIndicator" class="mt-3 mb-3" outlined hide-details auto-grow row-height="2">
                                                                    <template v-slot:label>{{
                                                                        $t("pdr.part2.Indicator")
                                                                        }}</template>
                                                                </v-textarea>
                                                            </td>
                                                            <td class="text-left border-elem-in-table  pt-2 pb-2">
                                                                <div class="mt-3 mb-3 " v-if="submitedPartThreeAndFour || userCanReadBool"> {{ objective.completionDate }}</div>
                                                                <v-menu v-else :close-on-content-click="true" :nudge-right="100" :nudge-top="3" transition="scale-transition" offset-y>
                                                                    <template v-slot:activator="{ on }">
                                                                        <v-text-field readonly class="mt-3 mb-3" :rules="ObjectifDatePart2Rules" append-icon="mdi-calendar-today" hide-details outlined v-model="objective.completionDate" v-on="on">
                                                                            <template v-slot:label>{{
                                                                        $t("pdr.part2.Date")
                                                                        }}</template>
                                                                        </v-text-field>
                                                                    </template>
                                                                    <v-date-picker landscape v-model="objective.completionDate" color="#00635b" locale="fr-fr"></v-date-picker>
                                                                </v-menu>
                                                            </td>
                                                            <td class="text-left border-elem-in-table pt-2 pb-2">
                                                                <div class="mt-3 mb-3 " v-if="submitedPartThreeAndFour || userCanReadBool">{{ objective.weighting }}</div>
                                                                <v-text-field v-else @change="calculateTotalWeight()" required :rules="ObjectifWeightPart2Rules" @keypress="isNumber($event)" v-model="objective.weighting" class="mt-3 mb-3 " type="number" step="5" hide-details suffix="%" outlined></v-text-field>
                                                            </td>
                                                            <td v-if="!submitedPartThreeAndFour || userCanReadBool" class="text-center border-elem-in-table">
                                                                <v-btn text class="delete-button" @click="deleteObjective(objective)">
                                                                    <v-icon>mdi-delete</v-icon>
                                                                </v-btn>
                                                            </td>
                                                        </tr>
                                                        <!-- FOOTER -->
                                                        <tr class="general-background">
                                                            <th class="text-right border-elem" colspan="4">{{$t('pdr.part3.TotalWeight')}}</th>
                                                            <th class="text-left border-elem-in-table" v-if="GlobalAchivementRatePart2Manager == 100" colspan="2">{{ GlobalAchivementRatePart2Manager }} %</th>
                                                            <th class="text-left border-elem" style="background-color: #B71C1C !important;" v-else colspan="2">{{ GlobalAchivementRatePart2Manager }} %</th>
                                                        </tr>
                                                    </tbody>
                                                </template>
                                            </v-simple-table>
                                        </template>
                                        <v-container v-if="!submitedPartThreeAndFour || userCanReadBool" fluid class="mr-0 pa-0 pr-3">
                                            <v-row justify="end">
                                                <v-btn class="ma-2" outlined color="#8ba79d" @click="addObjective" :disabled="employeeData.reviewSecondPart.objectivesManager.length === 10">
                                                    <v-icon color="#8ba79d" class="mr-2">mdi-plus</v-icon>
                                                  <b>{{$t('pdr.part3.ADDOBJECTIVE')}}</b>
                                                </v-btn>
                                                <v-btn class="ma-2" outlined color="#8ba79d" @click="openModal()">
                                                  <v-icon color="#8ba79d" class="mr-2">mdi-plus</v-icon>
                                                  <b>{{$t('pdr.part3.COPY_OBJECTIVE')}}</b>
                                                </v-btn>
                                            </v-row>
                                            <v-dialog v-model="dialog" width="800px">
                                              <v-card>
                                                <v-card-title class="text-h5">
                                                  {{$t('pdr.part3.SELECT_OBJECTIVES')}}
                                                </v-card-title>
                                                <v-card-text>
                                                  <v-expansion-panels v-model="openedPanel">
                                                    <v-expansion-panel>
                                                      <v-expansion-panel-header>
                                                        <b>{{$t('pdr.part3.EMP_OBJECTIVES')}}</b>
                                                      </v-expansion-panel-header>
                                                      <v-expansion-panel-content>
                                                        <v-list shaped>
                                                          <v-list-item-group v-model="objectiveToCopy" multiple>
                                                            <template v-for="(item, i) in employeeData.reviewSecondPart.objectivesEmployee">
                                                              <v-divider v-if="!item" :key="`divider-${i}`"></v-divider>

                                                              <v-list-item v-else :key="`item-${i}`" :value="item" active-class="text--accent-4">
                                                                <template v-slot:default="{ active }">
                                                                  <v-list-item-action>
                                                                    <v-checkbox :input-value="active" color="teal darken-4 accent-4"
                                                                    ></v-checkbox>
                                                                  </v-list-item-action>

                                                                  <v-list-item-content>
                                                                    <v-list-item-title>{{item.name}}</v-list-item-title>
                                                                  </v-list-item-content>
                                                                </template>
                                                              </v-list-item>
                                                            </template>
                                                          </v-list-item-group>
                                                        </v-list>
                                                      </v-expansion-panel-content>
                                                    </v-expansion-panel>
                                                    <v-spacer></v-spacer>
                                                    <v-expansion-panel>
                                                      <v-expansion-panel-header>
                                                        <b>{{$t('pdr.part3.MAN_OBJECTIVES')}}</b>
                                                      </v-expansion-panel-header>
                                                      <v-expansion-panel-content>
                                                        <v-list shaped>
                                                          <v-list-item-group v-model="objectiveToCopy" multiple>
                                                            <template v-for="(item, i) in managerObjectivesList">
                                                              <v-divider v-if="!item" :key="`divider-${i}`"></v-divider>

                                                              <v-list-item v-else :key="`item-${i}`" :value="item" active-class="text--accent-4">
                                                                <template v-slot:default="{ active }">
                                                                  <v-list-item-action>
                                                                    <v-checkbox :input-value="active" color="teal darken-4 accent-4"
                                                                    ></v-checkbox>
                                                                  </v-list-item-action>

                                                                  <v-list-item-content>
                                                                    <v-list-item-title>{{item.name}}</v-list-item-title>
                                                                  </v-list-item-content>
                                                                </template>
                                                              </v-list-item>
                                                            </template>
                                                          </v-list-item-group>
                                                        </v-list>
                                                      </v-expansion-panel-content>
                                                    </v-expansion-panel>
                                                  </v-expansion-panels>
                                                </v-card-text>
                                                <v-card-actions>
                                                  <v-spacer></v-spacer>
                                                  <p>
                                                    <v-btn @click="dialog = false" type="button" class="v-btn v-btn--contained theme--light v-size--default warning">
                                                      <span class="v-btn__content">{{$t('pdr.part3.CANCEL')}}</span>
                                                    </v-btn>
                                                    <v-btn @click="copyObjectives()" :disabled="this.objectiveToCopy.length === 0" type="button" class="v-btn v-btn--contained theme--light v-size--default success">
                                                      <span class="v-btn__content">{{$t('pdr.part3.ADD')}}</span>
                                                    </v-btn>
                                                  </p>
                                                </v-card-actions>
                                              </v-card>
                                            </v-dialog>
                                        </v-container>
                                      <v-alert
                                          v-if="employeeData.reviewSecondPart.objectivesManager.length > 5 && !submitedPartThreeAndFour && !userCanReadBool"
                                          color="#fb8c00" dark style="color: #000000DE">
                                        <b>{{$t('pdr.part3.ALERT_OBJECTIVE')}}</b>
                                      </v-alert>
                                    </v-card-text>
                                </v-card>

                                <!-- CAREER DEVELOPMENT -->
                                <v-card flat>
                                    <v-card-title class="secondary-titles" id="step_32" @click="$vuetify.goTo('#step_32', options)">
                                        <v-icon color="#8ba79d" class="mr-2">mdi-numeric-4-circle</v-icon> {{$t('pdr.part3.CareerDevelopmentPlan')}}
                                    </v-card-title>
                                    <v-card-text class="ml-5">

                                        <!-- Message d'alert -->
                                        <v-alert class="mr-3 mb-10 info-text margin-top" border="left" colored-border color="#8ba79d" type="info" elevation="4">
                                            <v-card-text v-html="labels['CAR_DEV_PLAN_'+locale.toUpperCase()]"> </v-card-text>
                                        </v-alert>

                                        <!-- CHECKBOXES OF CAREER DP -->
                                        <template>
                                            <v-card class="mr-3">
                                                <v-card-text>
                                                    <!-- Georgraphical -->
                                                    <div>
                                                        <span style="font-size: 16px">{{$t('pdr.part3.Geographical')}}
                                                            <v-icon v-if="employeeData.reviewSecondPart.careerDP.geographical" color="success">mdi-check-bold</v-icon>
                                                            <v-icon v-else color="error">mdi-close</v-icon>
                                                        </span>
                                                    </div>

                                                    <template>
                                                      <v-card outlined class="mr-3 ml-7 mt-5" v-if="employeeData.reviewSecondPart.careerDP.geographical" style="width: 40%">
                                                        <v-card-text>
                                                          <v-row>
                                                            <v-col>
                                                              <span class="mb-0" style="color: #212121">{{$t('pdr.part3.MOBILITY_RANGE')}}</span>
                                                            </v-col>
                                                            <v-col>
                                                              <span v-if="employeeData.reviewSecondPart.careerDP.mobilityRange">{{ employeeData.reviewSecondPart.careerDP.mobilityRange }}</span>
                                                            </v-col>
                                                          </v-row>
                                                        </v-card-text>
                                                      </v-card>
                                                    </template>

                                                    <!-- Functional -->
                                                    <div class="mt-5">
                                                        <span style="font-size: 16px">{{$t('pdr.part3.Functional')}}
                                                            <v-icon v-if="employeeData.reviewSecondPart.careerDP.functional" color="success">mdi-check-bold</v-icon>
                                                            <v-icon v-else color="error">mdi-close</v-icon>
                                                        </span>
                                                    </div>

                                                    <template>
                                                        <template>
                                                            <v-card outlined class="mr-3 ml-7 mt-5" v-if="employeeData.reviewSecondPart.careerDP.functional" style="width: 40%">
                                                                <v-card-text>
                                                                    <v-row>
                                                                        <v-col>
                                                                            <span class="mb-0" style="color: #212121">{{$t('pdr.part3.Forwhattype')}}</span>
                                                                        </v-col>
                                                                        <v-col>
                                                                            <span>{{ employeeData.reviewSecondPart.careerDP.position }}</span>
                                                                        </v-col>
                                                                    </v-row>
                                                                </v-card-text>
                                                            </v-card>
                                                        </template>

                                                        <!-- <template>
                                                            <v-card outlined class="mr-3 ml-7 mt-3" v-if="employeeData.reviewSecondPart.careerDP.functional" style="width: 40%">
                                                                <v-card-text>
                                                                    <v-row>
                                                                        <v-col>
                                                                            <span class="mb-0" style="color: #212121"> For which Business Unit(s) ?</span>
                                                                        </v-col>
                                                                        <v-col>
                                                                            <ul>
                                                                                <li v-for="b in chosenBu" v-bind:key="b">
                                                                                    {{ b }}
                                                                                </li>
                                                                            </ul>
                                                                        </v-col>
                                                                    </v-row>
                                                                </v-card-text>
                                                            </v-card>
                                                        </template> -->

                                                        <template>
                                                            <v-card outlined class="mr-3 ml-7 mt-3" v-if="employeeData.reviewSecondPart.careerDP.functional" style="width: 40%">
                                                                <v-card-text>
                                                                    <v-row>
                                                                        <v-col>
                                                                            <span class="mb-0" style="color: #212121"> {{$t('pdr.part3.Forwhich')}}</span>
                                                                        </v-col>
                                                                        <v-col>
                                                                            <ul>
                                                                                <li v-for="f in chosenFunctions" v-bind:key="f">
                                                                                    {{ f }}
                                                                                </li>
                                                                            </ul>
                                                                        </v-col>
                                                                    </v-row>
                                                                </v-card-text>

                                                            </v-card>
                                                        </template>
                                                    </template>

                                                    <!-- Last select of checkboxs sections (TIMEFRAME) -->
                                                    <template>
                                                        <v-card outlined class="mt-3 mr-3" v-if="employeeData.reviewSecondPart.careerDP.functional ||  employeeData.reviewSecondPart.careerDP.geographical" style="width: 40%">
                                                            <v-card-text>
                                                                <v-row>
                                                                    <v-col>
                                                                        <span class="mb-0" style="color: #212121">{{$t('pdr.part3.Whatwouldbe')}}</span>
                                                                    </v-col>
                                                                    <v-col>
                                                                        <span>{{ employeeData.reviewSecondPart.careerDP.timeframeMobility }}</span>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-card-text>
                                                        </v-card>
                                                    </template>
                                                </v-card-text>
                                            </v-card>
                                        </template>

                                        <br>
                                        <h5><b style="color: #8ba79d;">{{$t('pdr.part3.Commentsonmobility')}}</b></h5>
                                        <template>
                                            <v-simple-table>
                                                <template>
                                                    <thead>
                                                        <tr class="general-background">
                                                            <th class="text-left col-elem border-elem" style="width: 50%"><b>{{$t('pdr.reference.employee')}}</b></th>
                                                            <th class="text-left col-elem border-elem"><b>{{$t('pdr.reference.slmanager')}}</b></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td class="border-elem-in-table">
                                                                {{ employeeData.reviewSecondPart.careerDP.commentsEmployee }}
                                                            </td>
                                                            <td class="border-elem-in-table">
                                                                <span class="mt-3 mb-3 mr-3" v-if="submitedPartThreeAndFour || userCanReadBool">{{ employeeData.reviewSecondPart.careerDP.commentsManager }}</span>
                                                                <v-textarea maxlength="800" id="CommentsMobilitId" v-else  required :rules="CommentsMobilityRules" v-model="employeeData.reviewSecondPart.careerDP.commentsManager" class="mt-3 mb-3 mr-3" outlined hide-details auto-grow>
                                                                    <template v-slot:label>{{
                                                                        $t("pdr.part3.Commentsonmobility")
                                                                        }}</template>
                                                                </v-textarea>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </template>
                                            </v-simple-table>
                                        </template>
                                        <br>
                                        <br>
                                    <LangueBloc :languesFromServer="employeeData.reviewSecondPart.langues" :isSubmitted="submitedPartThreeAndFour || userCanReadBool" :isEmployee="false" />

                                        <br>
                                        <h5><b style="color: #8ba79d;">{{$t('pdr.part3.DevelopmentPlan')}}</b></h5>
                                        <v-alert class="mr-3 mb-10 info-text margin-top" border="left" colored-border color="#8ba79d" type="info" elevation="4">
                                            <v-card-text v-html="labels['DEV_PLAN_'+locale.toUpperCase()]"> </v-card-text>
                                        </v-alert>
                                        <template>
                                        </template>
                                        <template>
                                            <v-simple-table style="margin-top: 25px;">
                                                <template v-slot:default>
                                                    <thead>
                                                        <tr class="general-background">
                                                            <th style="background-color: white !important"></th>
                                                            <th class="text-left col-elem border-elem"><b>{{$t('pdr.reference.employee')}}</b></th>
                                                            <th class="text-left col-elem border-elem"><b>{{$t('pdr.reference.slmanager')}}</b></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td class="text-left border-elem general-background">{{$t('pdr.part3.70')}}</td>
                                                            <td class="text-left border-elem-in-table" style="width: 40%">
                                                                {{ employeeData.reviewSecondPart.careerDP.dpFirstItemEmployee }}
                                                            </td>
                                                            <td class="text-left border-elem-in-table" style="width: 40%">
                                                                <div class="mt-3 mb-3 mr-3" v-if="submitedPartThreeAndFour || userCanReadBool">{{ employeeData.reviewSecondPart.careerDP.dpFirstItemManager }}</div>
                                                                <v-textarea id="dpFirstItemEmployeeId" maxlength="800" v-else  required :rules="DPFirstPart2Rules" v-model="employeeData.reviewSecondPart.careerDP.dpFirstItemManager" class="mt-3 mb-3 mr-3" outlined hide-details auto-grow>
                                                                    <template v-slot:label>{{
                                                                        $t("pdr.part3.Comment")
                                                                        }}</template>
                                                                </v-textarea>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td class="text-left border-elem general-background">{{$t('pdr.part3.20')}}</td>
                                                            <td class="text-left border-elem-in-table">
                                                                {{ employeeData.reviewSecondPart.careerDP.dpSecondItemEmployee }}
                                                            </td>
                                                            <td class="text-left border-elem-in-table">
                                                                <div class="mt-3 mb-3 mr-3" v-if="submitedPartThreeAndFour || userCanReadBool">{{ employeeData.reviewSecondPart.careerDP.dpSecondItemManager }}</div>
                                                                <v-textarea id="dpSecondItemEmployeeId" maxlength="800" v-else  required :rules="DPSecondPart2Rules" v-model="employeeData.reviewSecondPart.careerDP.dpSecondItemManager" class="mt-3 mb-3 mr-3" outlined hide-details auto-grow>
                                                                    <template v-slot:label>{{
                                                                        $t("pdr.part3.Comment")
                                                                        }}</template>
                                                                </v-textarea>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td class="text-left border-elem general-background">{{$t('pdr.part3.10')}}</td>
                                                            <td class="text-left border-elem-in-table">
                                                              <template>
                                                                <h6>Training topics</h6>
                                                                <v-card elevation="2" v-if="employeeData.reviewSecondPart.careerDP.dpFirstEmployeeTopic" class="mt-3 mb-3 mr-3">
                                                                  <p class="ml-2">{{ employeeData.reviewSecondPart.careerDP.dpFirstEmployeeTopic.text }}</p>
                                                                  <hr/>
                                                                  <p class="ml-2">{{ employeeData.reviewSecondPart.careerDP.dpFirstEmployeeTopicComment }}</p>
                                                                </v-card>
                                                                <v-card elevation="2" v-if="employeeData.reviewSecondPart.careerDP.dpSecondEmployeeTopic" class="mt-3 mb-3 mr-3">
                                                                  <p class="ml-2">{{ employeeData.reviewSecondPart.careerDP.dpSecondEmployeeTopic.text }}</p>
                                                                  <hr/>
                                                                  <p class="ml-2">{{ employeeData.reviewSecondPart.careerDP.dpSecondEmployeeTopicComment }}</p>
                                                                </v-card>
                                                                <hr class="mr-3"/>
                                                                <h6>Comment</h6>
                                                                {{ employeeData.reviewSecondPart.careerDP.dpThirdItemEmployee }}
                                                              </template>
                                                            </td>
                                                            <td class="text-left border-elem-in-table">
                                                              <template v-if="submitedPartThreeAndFour || userCanReadBool">
                                                                <h6>Training topics</h6>
                                                                <v-card elevation="2" v-if="employeeData.reviewSecondPart.careerDP.dpFirstManagerTopic" class="mt-3 mb-3 mr-3">
                                                                  <p class="ml-2">{{ employeeData.reviewSecondPart.careerDP.dpFirstManagerTopic.text }}</p>
                                                                  <hr/>
                                                                  <p class="ml-2">{{ employeeData.reviewSecondPart.careerDP.dpFirstManagerTopicComment }}</p>
                                                                </v-card>
                                                                <v-card elevation="2" v-if="employeeData.reviewSecondPart.careerDP.dpSecondManagerTopic" class="mt-3 mb-3 mr-3">
                                                                  <p class="ml-2">{{ employeeData.reviewSecondPart.careerDP.dpSecondManagerTopic.text }}</p>
                                                                  <hr/>
                                                                  <p class="ml-2">{{ employeeData.reviewSecondPart.careerDP.dpSecondManagerTopicComment }}</p>
                                                                </v-card>

                                                                <hr class="mr-3"/>

                                                                <h6>Comment</h6>
                                                                {{ employeeData.reviewSecondPart.careerDP.dpThirdItemManager }}
                                                              </template>
                                                              <template v-else>
                                                                <h6>Training topics</h6>
                                                                <v-select v-model="employeeData.reviewSecondPart.careerDP.dpFirstManagerTopic" return-object :items="topics" :label="$t(`pdr.part3.SelectTrainingTopics`)" class="mt-3 mb-3 mr-3"  dense hide-details outlined></v-select>
                                                                <v-textarea required :rules="DPCommentTopic1Rules"  v-if="employeeData.reviewSecondPart.careerDP.dpFirstManagerTopic && employeeData.reviewSecondPart.careerDP.dpFirstManagerTopic.text"  maxlength="800" v-model="employeeData.reviewSecondPart.careerDP.dpFirstManagerTopicComment" class="mt-3 mb-3 mr-3" outlined hide-details auto-grow>
                                                                  <template v-slot:label>{{$t("pdr.part3.Comment")}}</template>
                                                                </v-textarea>
                                                                <v-select v-model="employeeData.reviewSecondPart.careerDP.dpSecondManagerTopic" return-object :items="topics" :label="$t(`pdr.part3.SelectTrainingTopics`)" class="mt-3 mb-3 mr-3"  dense hide-details outlined></v-select>
                                                                <v-textarea required :rules="DPCommentTopic2Rules"  v-if="employeeData.reviewSecondPart.careerDP.dpSecondManagerTopic && employeeData.reviewSecondPart.careerDP.dpSecondManagerTopic.text" maxlength="800" v-model="employeeData.reviewSecondPart.careerDP.dpSecondManagerTopicComment" class="mt-3 mb-3 mr-3" outlined hide-details auto-grow>
                                                                  <template v-slot:label>{{$t("pdr.part3.Comment") }}</template>
                                                                </v-textarea>

                                                                <hr class="mr-3"/>

                                                                <v-textarea id="dpThirdItemEmployeeId" maxlength="800" required :rules="DPThirdPart2Rules" v-model="employeeData.reviewSecondPart.careerDP.dpThirdItemManager" class="mt-3 mb-3 mr-3" outlined hide-details auto-grow>
                                                                  <template v-slot:label>{{$t("pdr.part3.Comment") }}</template>
                                                                </v-textarea>
                                                              </template>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </template>
                                            </v-simple-table>
                                        </template>
                                    </v-card-text>
                                    <EvalutationChargeTravail v-if="this.employeeData.user.travailEnFrance" :chargeTravail="employeeData.reviewSecondPart.chargeTravail" :isSubmitted="submitedPartThreeAndFour" :isEmployee="false" :isSlManager="true"/>

                                    <!-- NOTIFICATION PDR PART 3-4 -->
                                    <v-card flat>
                                        <v-card-title class="secondary-titles" id="step_33" @click="$vuetify.goTo('#step_33', options)">
                                            {{$t('pdr.part2.NotificationPDR')}}
                                        </v-card-title>
                                        <v-card-text>
                                            <v-alert class="mr-3 info-text margin-top" border="left" colored-border color="#8ba79d" type="info" elevation="4">
                                               {{$t('pdr.part2.Thissection')}}
                                            </v-alert>

                                            <template>
                                                <v-simple-table style="margin-top: 25px;">
                                                    <template v-slot:default>
                                                        <thead>
                                                            <tr>
                                                                <th class="text-left col-elem border-elem"><b></b></th>
                                                                <th class="text-left col-elem border-elem general-background"><b>{{$t('pdr.part2.Task')}}</b></th>
                                                                <th class="text-center col-elem border-elem general-background" style="width: 5%"><b>{{$t('pdr.part2.Signature')}}</b></th>
                                                                <th class="text-left col-elem border-elem general-background"><b>{{$t('pdr.part2.Date')}}</b></th>
                                                                <th class="text-left col-elem border-elem general-background" style="width: 50%;"><b>{{$t('pdr.part2.Commentsshared')}}</b></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td class="text-left border-elem general-background">{{$t('pdr.reference.slmanager')}}</td>
                                                                <td class="text-left border-elem-in-table">{{$t('pdr.part2.PDRformvalidation')}}</td>
                                                                <td class="text-center border-elem-in-table">
                                                                    <v-icon v-if="employeeData.reviewSecondPart.slmanagerSigned" color="success">mdi-check-bold</v-icon>
                                                                    <v-icon v-else>mdi-clock-outline</v-icon>
                                                                </td>
                                                                <td class="text-left border-elem-in-table">{{ employeeData.reviewSecondPart.slmanagerDate | simpleDate }}</td>
                                                                <td class="text-left border-elem-in-table">
                                                                    <div class="mt-3 mb-3" v-if="submitedPartThreeAndFour || userCanReadBool">{{ employeeData.reviewSecondPart.slmanagerComment }}</div>
                                                                    <v-textarea id="slmanagerComment" maxlength="800" v-else  required :rules="SLCommentPart2Rules" v-model="employeeData.reviewSecondPart.slmanagerComment" class="mt-3 mb-3" outlined hide-details auto-grow row-height="2">
                                                                        <template v-slot:label>{{
                                                                        $t("pdr.part2.SlManagerComment")
                                                                        }}</template>
                                                                    </v-textarea>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td class="text-left border-elem general-background">{{$t('pdr.reference.dlmanager')}}</td>
                                                                <td class="text-left border-elem-in-table">{{$t('pdr.part2.PDRformvalidation')}}</td>
                                                                <td class="text-center border-elem-in-table">
                                                                    <v-icon v-if="employeeData.reviewSecondPart.dlmanagerSigned" color="success">mdi-check-bold</v-icon>
                                                                    <v-icon v-else>mdi-clock-outline</v-icon>
                                                                </td>
                                                                <td class="text-left border-elem-in-table">{{ employeeData.reviewSecondPart.dlmanagerDate | simpleDate }}</td>
                                                                <td class="text-left border-elem-in-table"> {{ employeeData.reviewSecondPart.dlmanagerComment }} </td>
                                                            </tr>
                                                            <tr>
                                                                <td class="text-left border-elem general-background">{{$t('pdr.reference.employee')}}</td>
                                                                <td class="text-left border-elem-in-table">{{$t('pdr.part2.PDRformvalidation')}}</td>
                                                                <td class="text-center border-elem-in-table">
                                                                    <v-icon v-if="employeeData.reviewSecondPart.employeeSigned" color="success">mdi-check-bold</v-icon>
                                                                    <v-icon v-else>mdi-clock-outline</v-icon>
                                                                </td>
                                                                <td class="text-left border-elem-in-table">{{ employeeData.reviewSecondPart.employeeDate | simpleDate }}</td>
                                                                <td class="text-left border-elem-in-table">
                                                                    {{ employeeData.reviewSecondPart.employeeComment }}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </template>
                                                </v-simple-table>
                                            </template>
                                        </v-card-text>
                                    </v-card>
                                </v-card>
                            </v-card>
                        </v-form>
                        <div class="ml-2">
                            <h5><b style="color: #8ba79d;">{{$t('pdr.part3.Ifthereare')}}</b></h5>
                            <v-textarea maxlength="1400" v-model="employeeData.reviewSecondPart.commentsBetweenManagers" class="mt-3 mb-3 mr-4" outlined hide-details auto-grow></v-textarea>
                            <br>

                        </div>

                        <v-btn class=" ml-2 mb-3" color="grey lighten-3" @click="genralStepperIndex = 2">
                            {{$t('pdr.part2.PREVIOUS')}} <v-icon>mdi-arrow-up</v-icon>
                        </v-btn>
                        <br>
                        <v-btn v-if="!submitedPartThreeAndFour || userCanReadBool" @click="savePartThreeAndFour" class=" ml-2 mb-3" color="success">{{$t('pdr.part3.SAVEPART34')}}</v-btn>
                        <v-btn v-if="!submitedPartThreeAndFour || userCanReadBool" class=" ml-2 mb-3" color="red" style="color: white !important;" @click="submitPartThreeAndFour">{{$t('pdr.part3.SUBMITPART34')}}</v-btn>

                        <!-- SNACKBAR Part 3 - 4 -->
                        <v-snackbar v-model="snackbar" :color="snackBarColor" :timeout="snackBarTimeout">
                            <b>{{ snackBarText }} </b>
                        </v-snackbar>
                    </v-stepper-content>

                </v-stepper>
            </template>
            <br>
        </v-card>
    </div>
</div>
</template>

<style>
.margin-top {
    margin-top: 15px;
}

.review-card {
    margin-top: 113px;
}

textarea {
    margin: none;
}

.general-background {
    background-color: #00635b !important;
    color: white !important;
}

.second-background {
    background-color: #8ba79d !important;
}

.secondary-titles {
    font-size: 18px;
    font-weight: 600;
    cursor: pointer;
}

.secondary-titles:hover {
    background-color: #f0f0f0
}

.col-elem {
    color: white !important;

}

.border-elem {
    border: 2px solid white
}

.border-elem-in-table {
    border: 1px solid #F5F5F5;
}

.info-text {
    font-style: italic;
}

.second-table-general-header {
    background-color: #3f3a40;
}

.second-table-general-header:hover {
    background-color: #3f3a40 !important;
}

.second-table-specific-header {
    border-bottom: 3px solid #00635b;
}

.col-elem-specific-header {
    color: #00635b !important;

}

.no-hover-row:hover {
    background-color: white !important;

}

.delete-button:hover {
    color: red;
}

table {
    overflow: hidden !important;
}

label {
    margin-bottom: 0px !important;
}
</style>

<script>
import References from '@/components/References.vue'
import LangueBloc from '@/components/LangueBloc.vue'
import EvalutationChargeTravail from '@/components/EvalutationChargeTravail.vue'
import {
    mapGetters
} from 'vuex'
import axios from "axios";
import {authenticated} from "../../utils/authenticated";


export default {
    name: 'SLManagerReview',
    components: {
        References,
        LangueBloc,
        EvalutationChargeTravail
    },
    data() {
        return {
            savingInProgress: false,
            userCanReadBool: false,
            validPart1: true,
            validPart2: true,
            DateRules: [
                v => !!v || 'This field is required',
            ],
            SLAchievementRules: [
                v => ((v != null)) || 'This field is required',
                v => ((v !== "")) || 'This field is required',
                v => ((v <= 100)) || 'The number should be between 0 and 100',
                v => ((v >= 0)) || 'The number should be between 0 and 100',
                v => !v.toString().includes('.') || 'Incorrect type, please use integer only',
                v => !v.toString().includes(',') || 'Incorrect type, please use integer only',
            ],
            SLCommentRules: [
                v => !!v || 'This field is required',
            ],
            TechnicalSkillRules: [
                v => !!v || 'This field is required',
            ],
            TechnicalSkillCommentRules: [
                v => !!v || 'This field is required',
            ],
            FisrtRules: [
                v => !!v || 'This field is required',
            ],
            FisrtCommentRules: [
                v => !!v || 'This field is required',
            ],
            SecondRules: [
                v => !!v || 'This field is required',
            ],
            SecondCommentRules: [
                v => !!v || 'This field is required',
            ],
            ThirdRules: [
                v => !!v || 'This field is required',
            ],
            ThirdCommentRules: [
                v => !!v || 'This field is required',
            ],
            FourthRules: [
                v => !!v || 'This field is required',
            ],
            FourthCommentRules: [
                v => !!v || 'This field is required',
            ],
            LeadershipRules: [
                v => !!v || 'This field is required',
            ],
            LeadershipCommentRules: [
                v => !!v || 'This field is required',
            ],
            ExecutionRules: [
                v => !!v || 'This field is required',
            ],
            ExecutionCommentRules: [
                v => !!v || 'This field is required',
            ],
            OverallPerformanceRules: [
                v => !!v || 'This field is required',
            ],
            OverallPerformanceCommentRules: [
                v => !!v || 'This field is required',
            ],
            PDRSLRules: [
                v => !!v || 'This field is required',
            ],
            ObjectifNamePart2Rules: [
                v => !!v || 'This field is required',
            ],
            ObjectifDescriptionPart2Rules: [
                v => !!v || 'This field is required',
            ],
            ObjectifInidicatorPart2Rules: [
                v => !!v || 'This field is required',
            ],
            ObjectifDatePart2Rules: [
                v => !!v || 'This field is required',
            ],
            ObjectifWeightPart2Rules: [
                v => !!v || 'This field is required',
                v => ((v <= 100)) || 'The number should be between 0 and 100',
                v => ((v >= 0)) || 'The number should be between 0 and 100',
                v => !v.toString().includes('.') || 'Incorrect type, please use integer only',
                v => !v.toString().includes(',') || 'Incorrect type, please use integer only',
            ],
            CommentsMobilityRules: [
                v => !!v || 'This field is required',
            ],
            DPFirstPart2Rules: [
                v => !!v || 'This field is required',
            ],
            DPSecondPart2Rules: [
                v => !!v || 'This field is required',
            ],
            DPThirdPart2Rules: [
                v => !!v || 'This field is required',
            ],
            SLCommentPart2Rules: [
                v => !!v || 'This field is required',
            ],
            DPCommentTopic1Rules: [
              v => !!v || 'This field is required',
            ],
            DPCommentTopic2Rules: [
              v => !!v || 'This field is required',
            ],
            lazyPart1: false,
            lazyPart2: false,
            error: false,
            errorMessage: '',
            submitedPartOneAndTwo: false,
            submitedPartThreeAndFour: false,
            employeeData: null,
            assessingEmployee: null,
            reviewFirstPartToSybmit: null,
            yearOfReview: null,
            showEmployeeProposal: false,
            statusIsEmployeeProposalPart1_2: false,
            statusIsEmployeeProposalPart3_4: false,
            GlobalAchivementRatePart1Manager: 0,
            
            selectedTechnicalSkill: '',
            selectedTechnicalSkillManager: '',

            
            selectedCustomerCentric: '',
            selectedFeelingvalued: '',
            selectedOpenCommunication: '',
            selectedWorkingTogether: '',
            selectedLeadership: '',
            selectedExectionExcellence: '',

            selectedCustomerCentricManager: '',
            selectedFeelingvaluedManager: '',
            selectedOpenCommunicationManager: '',
            selectedWorkingTogetherManager: '',
            selectedLeadershipManager: '',
            selectedExectionExcellenceManager: '',

            
            selectedOverallPerformance: '',
            selectedOverallPerformanceManager: '',
            
            availableBU: [],
            chosenBu: [],
            availableFunctions: [],
            chosenFunctions: [],
            modelAvailableBU: [],
            modelChosenBU: [],
            modelAvailableFunction: [],
            modelChosenFunction: [],
            GlobalAchivementRatePart2Employee: 0,
            GlobalAchivementRatePart2Manager: 0,
            genralStepperIndex: 1,
            Stepper2Index: 1,
            Stepper3Index: 1,
            dateFormatted: null,
            duration: 400,
            offset: 113,
            easing: 'easeInOutCubic',
            snackbar: false,
            snackBarText: '',
            snackBarColor: '',
            snackBarTimeout: 3000,
            dialog: false,
            objectiveToCopy: [],
            managerObjectivesList: [],
            openedPanel: null,
            topic: {
              refTopicDto: {
                id: null,
                topicOrder: null,
                topic: "",
                active: null,
                refTopicTranslationDtoList: []
              },
              language: {
                code: null,
                label: null
              },
              text: ""
            },
            topics : [this.topic],
            initialLoad: true,
        }
    },
    filters: {
        simpleDate: function (value) {
            if (!value) return ''
            const [year, month, day] = value.split('-')
            return `${day}/${month}/${year}`
        }
    },
    methods: {
        isNumber (event) {
            const keysAllowed = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
            const keyPressed = event.key;
            if (!keysAllowed.includes(keyPressed)) {
                event.preventDefault()
            }
        },
      loadRefTopicData() {
        const apiURL = process.env.VUE_APP_ROOT_API_PATH +`api/ref/topics/findAll/active/language/${this.$i18n.locale.toUpperCase()}`;
        const config = {
          headers: {'Content-Type': 'application/json'},
          withCredentials: true
        };
        axios.get(apiURL, config)
            .then(response => {
              this.topics = response.data.data;
              this.topics.unshift(this.topic);
            })
            .catch(() => {
              this.message = "An error occurred, please try again later";
              this.messageType = "error";
              this.showMessage = true;
            });
      },
      formatDate(date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },
        parseDate(date) {
            if (!date) return null

            const [day, month, year] = date.split('/')
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        },
        getYearOfReview(year) {
            return (+year);
        },
        badParamPartOneAndTwo: function () {
            if (this.employeeData.reviewFirstPart.objectivesEmployee) {
                for (let i = 0; i < this.employeeData.reviewFirstPart.objectivesEmployee.length; i++) {
                    let objective = this.employeeData.reviewFirstPart.objectivesEmployee[i];
                    if (objective.slManagerAchievements) {
                        let weightString = objective.slManagerAchievements.toString();
                        if (weightString.includes('.') || weightString.includes(',')) {
                            return i;
                        }
                    }
                }
            }
            return null;
        },
        badParam: function () {
            if (this.employeeData.reviewSecondPart.objectivesManager) {
                for (let i = 0; i < this.employeeData.reviewSecondPart.objectivesManager.length; i++) {
                    let objective = this.employeeData.reviewSecondPart.objectivesManager[i];
                    if (objective.weighting) {
                        let weightString = objective.weighting.toString();
                        if (weightString.includes('.') || weightString.includes(',')) {
                            return i;
                        }
                    }
                }
            }
            return null;
        },
        calculateTotalWeight() {
            let varTemp2 = 0;

            this.employeeData.reviewSecondPart.objectivesManager.forEach(function (element) {
                varTemp2 += +element.weighting;
            });
            this.GlobalAchivementRatePart2Manager = varTemp2;
        },
        getGlobalAchivement(tab) {
            let varToReturn = 0;
            if (tab) {
                tab.forEach(function (element) {
                    if (element.manager) {
                        varToReturn += element.weighting;
                    }
                })
            }
            return varToReturn;
        },
        getGlobalAchivementPart1(tab) {
            let varToReturn = 0;
            if (tab) {
                tab.forEach(function (element) {
                    varToReturn += ((+element.weighting) * (+element.slManagerAchievements)) / 100;
                })
            }
            return parseFloat(varToReturn.toFixed(2));
        },
        calculateTotalWeightPart1() {
            let varTemp = 0;
            this.employeeData.reviewFirstPart.objectivesEmployee.forEach(function (element) {
                varTemp += ((+element.weighting) * (+element.slManagerAchievements)) / 100;
            })
            this.GlobalAchivementRatePart1Manager = parseFloat(varTemp.toFixed(2));
        },
        addObjective() {
            let objective = {
                id: null,
                name: null,
                description: null,
                successIndicator: null,
                completionDate: null,
                weighting: 0,
                comments: null,
                isManager: true
            }
            this.employeeData.reviewSecondPart.objectivesManager.push(objective);
        },

        copyObjectives(){
          if((this.employeeData.reviewSecondPart.objectivesManager.length) + (this.objectiveToCopy.length) > 10){
            this.snackBarText = this.$t('pdr.part3.MAX_OBJECTIVES');
            this.snackBarColor = 'red';
            this.snackbar = true;
          }else{
            this.dialog = false;
            for (let i = 0; i < this.objectiveToCopy.length; i++){
              this.employeeData.reviewSecondPart.objectivesManager.push({
                name:this.objectiveToCopy[i].name,
                description:this.objectiveToCopy[i].description,
                successIndicator:this.objectiveToCopy[i].successIndicator,
                completionDate:this.objectiveToCopy[i].completionDate,
                weighting:this.objectiveToCopy[i].weighting,
                comments:this.objectiveToCopy[i].comments,
                isManager:true
              });
              this.calculateTotalWeight();
            }
            this.snackBarText = this.$t('pdr.part3.OBJECTIVES_COPIED');
            this.snackBarColor = 'green';
            this.snackbar = true;
            this.resetObjectivesToCopy();
          }
        },

        openModal(){
          this.openedPanel = null;
          this.getReviewSecondPart();
          this.resetObjectivesToCopy();

          setTimeout(() => {
            this.dialog = true;
          }, 10);
        },

        resetObjectivesToCopy(){
          this.objectiveToCopy = [];
        },

        deleteObjective(objective) {
            this.calculateTotalWeight();
            var index = this.employeeData.reviewSecondPart.objectivesManager.indexOf(objective);
            if (index > -1) {
                this.employeeData.reviewSecondPart.objectivesManager.splice(index, 1);
                this.calculateTotalWeight();
            }
        },

        showHideObjectivesEMployee() {
            this.showEmployeeProposal = !this.showEmployeeProposal
        },

        availabaleBuToChosenBu() {

            for (let i = 0; i < this.modelAvailableBU.length; i++) {
                this.chosenBu.push(this.availableBU[this.modelAvailableBU[i]]);
            }

            for (let i = 0; i < this.chosenBu.length; i++) {

                var index = this.availableBU.indexOf(this.chosenBu[i]);
                if (index > -1) {
                    this.availableBU.splice(index, 1);
                }
            }

            this.modelAvailableBU = [];
        },

        chosenBuToAvailableBu() {

            for (let i = 0; i < this.modelChosenBU.length; i++) {
                this.availableBU.push(this.chosenBu[this.modelChosenBU[i]]);
            }

            for (let i = 0; i < this.availableBU.length; i++) {

                var index = this.chosenBu.indexOf(this.availableBU[i]);
                if (index > -1) {
                    this.chosenBu.splice(index, 1);
                }
            }

            this.modelChosenBU = [];
        },
        availabaleFunctionToChosenFunction() {

            for (let i = 0; i < this.modelAvailableFunction.length; i++) {
                this.chosenFunctions.push(this.availableFunctions[this.modelAvailableFunction[i]]);
            }

            for (let i = 0; i < this.chosenFunctions.length; i++) {

                var index = this.availableFunctions.indexOf(this.chosenFunctions[i]);
                if (index > -1) {
                    this.availableFunctions.splice(index, 1);
                }
            }

            this.modelAvailableFunction = [];
        },

        chosenFunctionToAvailableFunction() {

            for (let i = 0; i < this.modelChosenFunction.length; i++) {
                this.availableFunctions.push(this.chosenFunctions[this.modelChosenFunction[i]]);
            }

            for (let i = 0; i < this.availableFunctions.length; i++) {

                var index = this.chosenFunctions.indexOf(this.availableFunctions[i]);
                if (index > -1) {
                    this.chosenFunctions.splice(index, 1);
                }
            }

            this.modelChosenFunction = [];
        },

        // METHODE D'IMPRESSION DU PDF
        printEmployeePDF: function () {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            var myMethod = "post";
            fetch(process.env.VUE_APP_ROOT_API_PATH + "api/pdf/general?userId=" + this.employeeData.user.id + "&year=" + this.employeeData.campaign.year, {
                    method: myMethod,
                    credentials: 'include',
                    headers: myHeaders,
                }).then(response => response.blob())
                .then(blob => {
                    var url = window.URL.createObjectURL(blob);
                    var a = document.createElement('a');
                    a.target = "_Blank"
                    a.href = url;
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                });
        },

        // SAVE METHOD PART 1 AND 2
        savePartOneAndTwo: function () {
              authenticated().then((result) => {
                if (!result) {
                  this.snackbar = true;
                  this.snackBarText = this.$t('pdr.unsaved');
                  this.snackBarColor = 'error';
                } else {
                  var myHeaders = new Headers();
                  myHeaders.append("Content-Type", "application/json");
                  var myMethod = "post";

                  if (this.badParamPartOneAndTwo() != null) {
                    this.snackbar = true;
                    this.snackBarColor = 'error'
                    this.snackBarText = 'The achievement has an incorrect type, please use integer only';
                    return;
                  }
                  this.loadStatusFirstPart().then((status) => {
                    if (status === 0) {
                      this.snackbar = true;
                      this.snackBarColor = 'error';
                      this.snackBarText = this.$t("pdr.pdrHasChanged");
                    } else {

                      // Selected assessing performance
                      this.employeeData.reviewFirstPart.assessingManagerDto.technicalSkillsRating = this.technicalSkillsItems.find(i => i.value === this.selectedTechnicalSkillManager).key
                      this.employeeData.reviewFirstPart.assessingManagerDto.customerCentricRating = this.cultureAndValuesItems.find(i => i.value === this.selectedCustomerCentricManager).key
                      this.employeeData.reviewFirstPart.assessingManagerDto.feelingValuedRating = this.cultureAndValuesItems.find(i => i.value === this.selectedFeelingvaluedManager).key
                      this.employeeData.reviewFirstPart.assessingManagerDto.openCommunicationRating = this.cultureAndValuesItems.find(i => i.value === this.selectedOpenCommunicationManager).key
                      this.employeeData.reviewFirstPart.assessingManagerDto.workingTogetherRating = this.cultureAndValuesItems.find(i => i.value === this.selectedWorkingTogetherManager).key
                      this.employeeData.reviewFirstPart.assessingManagerDto.leadershipRating = this.leadershipItems.find(i => i.value === this.selectedLeadershipManager).key
                      this.employeeData.reviewFirstPart.assessingManagerDto.executionExcellenceRating = this.cultureAndValuesItems.find(i => i.value === this.selectedExectionExcellenceManager).key
                      this.employeeData.reviewFirstPart.assessingManagerDto.overallPerformanceRating = this.overallPerformanceItems.find(i => i.value === this.selectedOverallPerformanceManager).key

                      fetch(process.env.VUE_APP_ROOT_API_PATH + "api/reviews/firstPart?submit=false", {
                        method: myMethod,
                        credentials: 'include',
                        headers: myHeaders,
                        body: JSON.stringify(this.employeeData.reviewFirstPart),

                      }).then((response) => {
                        this.snackbar = true;
                        if (response.status >= 200 && response.status < 300) {
                          this.snackBarText = this.$t('pdr.part3.Savedsuccessfully12');
                          this.snackBarColor = 'success'
                        } else {
                          this.snackBarText = 'Something went wrong';
                          this.snackBarColor = 'error'
                        }
                      })
                    }
                  });
                }
              });
        },

      savePartOneAndTwoWithTimer() {
        if (!this.savingInProgress) {
          this.savingInProgress = true;

          setTimeout(() => {
            this.savePartOneAndTwo();
            this.savingInProgress = false;
          }, 30000);
        }
      },

      savePartThreeAndFourWithTimer() {
        if (!this.savingInProgress) {
          this.savingInProgress = true;

          setTimeout(() => {
            this.savePartThreeAndFour();
            this.savingInProgress = false;
          }, 30000);
        }
      },

        // METHODE SUBMIT PART 1 - 2
        submitPartOneAndTwo: function () {
          authenticated().then((result) => {
                if (!result) {
                  this.snackbar = true;
                  this.snackBarText = this.$t('pdr.unsaved');
                  this.snackBarColor = 'error';
                } else {
                  if (this.$refs.formPart1.validate() && this.GlobalAchivementRatePart1Manager <= 100) {
                      var myHeaders = new Headers();
                      myHeaders.append("Content-Type", "application/json");
                      var myMethod = "post";

                      if (this.badParamPartOneAndTwo() != null) {
                          this.snackbar = true;
                          this.snackBarColor = 'error'
                          this.snackBarText = 'The achievement has an incorrect type, please use integer only';
                          return;
                      }

                      this.loadStatusFirstPart().then((status) => {
                          if (status === 0) {
                              this.snackbar = true;
                              this.snackBarColor = 'error';
                              this.snackBarText = this.$t("pdr.pdrHasChanged");
                          }
                          else {

                      // Selected assessing performance
                      this.employeeData.reviewFirstPart.assessingManagerDto.technicalSkillsRating = this.technicalSkillsItems.find(i => i.value === this.selectedTechnicalSkillManager).key
                      this.employeeData.reviewFirstPart.assessingManagerDto.customerCentricRating = this.cultureAndValuesItems.find(i => i.value === this.selectedCustomerCentricManager).key
                      this.employeeData.reviewFirstPart.assessingManagerDto.feelingValuedRating = this.cultureAndValuesItems.find(i => i.value === this.selectedFeelingvaluedManager).key
                      this.employeeData.reviewFirstPart.assessingManagerDto.openCommunicationRating = this.cultureAndValuesItems.find(i => i.value === this.selectedOpenCommunicationManager).key
                      this.employeeData.reviewFirstPart.assessingManagerDto.workingTogetherRating = this.cultureAndValuesItems.find(i => i.value === this.selectedWorkingTogetherManager).key
                      this.employeeData.reviewFirstPart.assessingManagerDto.leadershipRating = this.leadershipItems.find(i => i.value === this.selectedLeadershipManager).key
                      this.employeeData.reviewFirstPart.assessingManagerDto.executionExcellenceRating = this.cultureAndValuesItems.find(i => i.value === this.selectedExectionExcellenceManager).key
                      this.employeeData.reviewFirstPart.assessingManagerDto.overallPerformanceRating = this.overallPerformanceItems.find(i => i.value === this.selectedOverallPerformanceManager).key

                      fetch(process.env.VUE_APP_ROOT_API_PATH + "api/reviews/firstPart?submit=true", {
                          method: myMethod,
                          credentials: 'include',
                          headers: myHeaders,
                          body: JSON.stringify(this.employeeData.reviewFirstPart),

                      }).then((response) => {
                          this.snackbar = true;
                          if (response.status >= 200 && response.status < 300) {
                              this.submitedPartOneAndTwo = true;
                              this.snackBarText = this.$t('pdr.part3.Submittedsuccessfully12');
                              this.snackBarColor = 'success'
                              this.loadReview();
                          } else {
                              if (response.status == 401) {
                                  this.snackBarText = 'Something went wrong : you have been deconnected';
                              } else {
                                  this.snackBarText = 'Something went wrong';
                              }
                              this.snackBarColor = 'error'
                          }
                      })
                  }});
                  } else {
                      this.snackbar = true;
                      this.snackBarText = this.$t('pdr.part3.Checkallfields');
                      this.snackBarColor = 'error'
                  }
                }
              });
        },

        // METHODE SAVE PART 3 - 4
        savePartThreeAndFour: function () {
              authenticated().then((result) => {
                if (!result) {
                  this.snackbar = true;
                  this.snackBarText = this.$t('pdr.unsaved');
                  this.snackBarColor = 'error';
                } else {
                  var myHeaders = new Headers();
                  myHeaders.append("Content-Type", "application/json");
                  var myMethod = "post";

                  if (this.badParam() != null) {
                    this.snackbar = true;
                    this.snackBarColor = 'error'
                    this.snackBarText = 'The weight has an incorrect type, please use integer only';
                    return;
                  }

                  this.loadStatusSecondPart().then((status) => {
                    if (status === 0) {
                      this.snackbar = true;
                      this.snackBarColor = 'error';
                      this.snackBarText = this.$t("pdr.pdrHasChanged");
                    } else {

                      //vars to Submit (SAVE)
                      this.employeeData.reviewSecondPart.careerDP.availableGroupFunction = this.availableFunctions;
                      this.employeeData.reviewSecondPart.careerDP.choosenGroupFunction = this.chosenFunctions;
                      this.employeeData.reviewSecondPart.careerDP.availableBusinessUnit = this.availableBU;
                      this.employeeData.reviewSecondPart.careerDP.choosenBusinessUnit = this.chosenBu;

                      if (!this.employeeData.reviewSecondPart.careerDP.dpFirstManagerTopic || !this.employeeData.reviewSecondPart.careerDP.dpFirstManagerTopic.text) {
                        this.employeeData.reviewSecondPart.careerDP.dpFirstManagerTopic = null;
                      }

                      if (!this.employeeData.reviewSecondPart.careerDP.dpSecondManagerTopic || !this.employeeData.reviewSecondPart.careerDP.dpSecondManagerTopic.text) {
                        this.employeeData.reviewSecondPart.careerDP.dpSecondManagerTopic = null;
                      }
                      fetch(process.env.VUE_APP_ROOT_API_PATH + "api/reviews/secondPart?submit=false", {
                        method: myMethod,
                        credentials: 'include',
                        headers: myHeaders,
                        body: JSON.stringify(this.employeeData.reviewSecondPart),

                      }).then((response) => {
                        this.snackbar = true;
                        if (response.status >= 200 && response.status < 300) {
                          this.snackBarText = this.$t('pdr.part3.Savedsuccessfully34');
                          this.snackBarColor = 'success'
                          this.loadReview();
                        } else {
                          this.snackBarText = 'Something went wrong';
                          this.snackBarColor = 'error'
                        }
                      })
                    }
                  });
                }
              });
        },

        // METHODE SUBMIT PART 3 - 4
        submitPartThreeAndFour: function () {
          authenticated().then((result) => {
                if (!result) {
                  this.snackbar = true;
                  this.snackBarText = this.$t('pdr.unsaved');
                  this.snackBarColor = 'error';
                } else {
                  if (this.$refs.formPart2.validate() && this.GlobalAchivementRatePart2Manager === 100) {
                    var myHeaders = new Headers();
                    myHeaders.append("Content-Type", "application/json");
                    var myMethod = "post";

                    if (this.badParam() != null) {
                      this.snackbar = true;
                      this.snackBarColor = 'error'
                      this.snackBarText = 'The weight has an incorrect type, please use integer only';
                      return;
                    }

                    this.loadStatusSecondPart().then((status) => {
                      if (status === 0) {
                        this.snackbar = true;
                        this.snackBarColor = 'error';
                        this.snackBarText = this.$t("pdr.pdrHasChanged");
                        return;
                      } else {

                        //vars to Submit (SAVE)
                        this.employeeData.reviewSecondPart.careerDP.availableGroupFunction = this.availableFunctions;
                        this.employeeData.reviewSecondPart.careerDP.choosenGroupFunction = this.chosenFunctions;
                        this.employeeData.reviewSecondPart.careerDP.availableBusinessUnit = this.availableBU;
                        this.employeeData.reviewSecondPart.careerDP.choosenBusinessUnit = this.chosenBu;

                        if (!this.employeeData.reviewSecondPart.careerDP.dpFirstManagerTopic || !this.employeeData.reviewSecondPart.careerDP.dpFirstManagerTopic.text) {
                          this.employeeData.reviewSecondPart.careerDP.dpFirstManagerTopic = null;
                        }

                        if (!this.employeeData.reviewSecondPart.careerDP.dpSecondManagerTopic || !this.employeeData.reviewSecondPart.careerDP.dpSecondManagerTopic.text) {
                          this.employeeData.reviewSecondPart.careerDP.dpSecondManagerTopic = null;
                        }

                        fetch(process.env.VUE_APP_ROOT_API_PATH + "api/reviews/secondPart?submit=true", {
                          method: myMethod,
                          credentials: 'include',
                          headers: myHeaders,
                          body: JSON.stringify(this.employeeData.reviewSecondPart),

                        }).then((response) => {
                          this.snackbar = true;
                          if (response.status >= 200 && response.status < 300) {
                            this.submitedPartThreeAndFour = true;
                            this.snackBarText = this.$t('pdr.part3.Submittedsuccessfully34');
                            this.snackBarColor = 'success'
                            this.loadReview();
                          } else {
                            if (response.status == 401) {
                              this.snackBarText = 'Something went wrong : you have been deconnected';
                            } else {
                              this.snackBarText = 'Something went wrong';
                            }
                            this.snackBarColor = 'error'
                          }
                        })
                      }
                    });
                  } else {
                    this.snackbar = true;
                    this.snackBarText = this.$t('pdr.part3.Checkallfields');
                    this.snackBarColor = 'error'
                  }
                }
              });
        },
        loadStatusFirstPart: function () {
            return fetch(process.env.VUE_APP_ROOT_API_PATH + "api/reviews/" + this.$route.params.id, {
                method: "get",
                credentials: 'include'
            })
            .then((response) => response.json())
            .then((response) => {
                if (response.data.reviewFirstPart.status.code != this.employeeData.reviewFirstPart.status.code){
                    return 0;
                } else {
                    return 1;
                }
            });
        },
        loadStatusSecondPart: function () {
            return fetch(process.env.VUE_APP_ROOT_API_PATH + "api/reviews/" + this.$route.params.id, {
                method: "get",
                credentials: 'include'
            })
            .then((response) => response.json())
            .then((response) => {
                if (response.data.reviewSecondPart.status.code != this.employeeData.reviewSecondPart.status.code){
                    return 0;
                } else {
                    return 1;
                }
            });
        },
         loadReview: function () {
             this.user.langue;
        fetch(process.env.VUE_APP_ROOT_API_PATH + "api/reviews/" + this.$route.params.id, {
                method: "get",
                credentials: 'include'
            })
            .then((response) => {
                return response.json()
            })
            .then((response) => {
                this.employeeData = response.data;
                if (this.employeeData.reviewFirstPart) {
                    this.employeeData.reviewFirstPart.type = "manager";
                    this.employeeData.reviewFirstPart.employee = {};
                    this.employeeData.reviewFirstPart.slManager = {};
                    this.employeeData.reviewFirstPart.dlManager = {};
                    this.employeeData.reviewFirstPart.employee.id = this.employeeData.user.id;
                    if (this.employeeData.SLmanager) {
                        this.employeeData.reviewFirstPart.slManager.id = this.employeeData.SLmanager.id;
                    }
                    if (this.employeeData.DLmanager) {
                        this.employeeData.reviewFirstPart.dlManager.id = this.employeeData.DLmanager.id;
                    }

                    if (this.employeeData.reviewFirstPart.status.code === "EMP_PROP") {
                        this.statusIsEmployeeProposalPart1_2 = true;
                    } else {
                        this.statusIsEmployeeProposalPart1_2 = false;
                    }
                }
                this.employeeData.reviewSecondPart.type = "manager";
                this.employeeData.reviewSecondPart.employee = {};
                this.employeeData.reviewSecondPart.slManager = {};
                this.employeeData.reviewSecondPart.dlManager = {};
                this.employeeData.reviewSecondPart.employee.id = this.employeeData.user.id;
                if (this.employeeData.SLmanager) {
                    this.employeeData.reviewSecondPart.slManager.id = this.employeeData.SLmanager.id;
                }
                if (this.employeeData.DLmanager) {
                    this.employeeData.reviewSecondPart.dlManager.id = this.employeeData.DLmanager.id;
                }

                if (this.employeeData.reviewSecondPart.status.code === "EMP_PROP") {
                    this.statusIsEmployeeProposalPart3_4 = true;
                } else {
                    this.statusIsEmployeeProposalPart3_4 = false;
                }
                if (this.employeeData.reviewFirstPart && this.employeeData.reviewFirstPart.status) {
                    if (this.employeeData.reviewFirstPart.status.code === "SLM_PROP" || this.employeeData.reviewFirstPart.status.code === "SLM_BACK") {
                        this.submitedPartOneAndTwo = false;
                    } else {
                        this.submitedPartOneAndTwo = true;
                    }
                }
                if (this.employeeData.reviewSecondPart.status.code === "SLM_PROP" || this.employeeData.reviewSecondPart.status.code === "SLM_BACK") {
                    this.submitedPartThreeAndFour = false;
                } else {
                    this.submitedPartThreeAndFour = true;
                }
                if (this.employeeData.reviewFirstPart) {
                    this.assessingEmployee = this.employeeData.reviewFirstPart.assessingEmployeeDto;
                    this.assessingManager = this.employeeData.reviewFirstPart.assessingManagerDto;
                }
                this.calculateTotalWeight();

                let varTemp1 = 0;
                this.employeeData.reviewSecondPart.objectivesEmployee.forEach(function (element) {
                    varTemp1 += +element.weighting;
                });
                this.GlobalAchivementRatePart2Employee = varTemp1;

                //pour avoir au minimum trois objectifs
                while (this.employeeData.reviewSecondPart.objectivesManager.length < 3) {
                    this.addObjective();
                }

                //get l'année de la review à afficher
                this.yearOfReview = this.getYearOfReview(this.employeeData.campaign.year);

                // get global achievement rate Part 1
                if (this.employeeData.reviewFirstPart) {
                    this.GlobalAchivementRatePart1Manager = this.getGlobalAchivementPart1(this.employeeData.reviewFirstPart.objectivesEmployee);
                }
                // get global achievement rate Part 2
                this.GlobalAchivementRatePart2Manager = this.getGlobalAchivement(this.employeeData.reviewSecondPart.objectivesManager);

                // Gestion des selects
                if (this.assessingEmployee) {
                    this.selectedTechnicalSkill = this.technicalSkillsItems.find(i => i.key === this.assessingEmployee.technicalSkillsRating).value
                    this.selectedCustomerCentric = this.cultureAndValuesItems.find(i => i.key === this.assessingEmployee.customerCentricRating).value
                    this.selectedFeelingvalued = this.cultureAndValuesItems.find(i => i.key === this.assessingEmployee.feelingValuedRating).value
                    this.selectedOpenCommunication = this.cultureAndValuesItems.find(i => i.key === this.assessingEmployee.openCommunicationRating).value
                    this.selectedWorkingTogether = this.cultureAndValuesItems.find(i => i.key === this.assessingEmployee.workingTogetherRating).value
                    this.selectedLeadership = this.leadershipItems.find(i => i.key === this.assessingEmployee.leadershipRating).value
                    this.selectedExectionExcellence = this.cultureAndValuesItems.find(i => i.key === this.assessingEmployee.executionExcellenceRating).value
                    this.selectedOverallPerformance = this.overallPerformanceItems.find(i => i.key === this.assessingEmployee.overallPerformanceRating).value
                }
                if (this.assessingManager) {
                    this.selectedTechnicalSkillManager = this.technicalSkillsItems.find(i => i.key === this.assessingManager.technicalSkillsRating).value
                    this.selectedCustomerCentricManager = this.cultureAndValuesItems.find(i => i.key === this.assessingManager.customerCentricRating).value
                    this.selectedFeelingvaluedManager = this.cultureAndValuesItems.find(i => i.key === this.assessingManager.feelingValuedRating).value
                    this.selectedOpenCommunicationManager = this.cultureAndValuesItems.find(i => i.key === this.assessingManager.openCommunicationRating).value
                    this.selectedWorkingTogetherManager = this.cultureAndValuesItems.find(i => i.key === this.assessingManager.workingTogetherRating).value
                    this.selectedLeadershipManager = this.leadershipItems.find(i => i.key === this.assessingManager.leadershipRating).value
                    this.selectedExectionExcellenceManager = this.cultureAndValuesItems.find(i => i.key === this.assessingManager.executionExcellenceRating).value
                    this.selectedOverallPerformanceManager = this.overallPerformanceItems.find(i => i.key === this.assessingManager.overallPerformanceRating).value
                }
                // gestion des tableau Available/Chosen
                if (this.employeeData.reviewSecondPart.careerDP.availableBusinessUnit != null) {
                    this.availableBU = this.employeeData.reviewSecondPart.careerDP.availableBusinessUnit;
                }

                if (this.employeeData.reviewSecondPart.careerDP.choosenBusinessUnit != null) {
                    this.chosenBu = this.employeeData.reviewSecondPart.careerDP.choosenBusinessUnit;
                }

                if (this.employeeData.reviewSecondPart.careerDP.availableGroupFunction != null) {
                    this.availableFunctions = this.employeeData.reviewSecondPart.careerDP.availableGroupFunction;
                }

                if (this.employeeData.reviewSecondPart.careerDP.choosenGroupFunction != null) {
                    this.chosenFunctions = this.employeeData.reviewSecondPart.careerDP.choosenGroupFunction;
                }
                 this.$store.dispatch("setAdditionalMessage", this.$t('pdr.Performancereview')+ " " + this.yearOfReview + " " + this.$t('pdr.of') + " " + response.data.user.firstName + " " + response.data.user.lastName);

                 //can see
                this.userCanReadBool = (this.employeeData && this.employeeData.newSLmanager && this.employeeData.slManager && this.user) ?
                    (this.employeeData.newSLmanager.id === this.user.id && this.employeeData.slManager.id !== this.user.id) :
                    false;
                setTimeout(() => {
                  this.initialLoad = false;
                }, 1000);
            });
         },
      getReviewSecondPart: function () {
        fetch(process.env.VUE_APP_ROOT_API_PATH + "api/review-second-part/my/" + this.yearOfReview, {
          method: "get",
          credentials: 'include'
        }).then((response) => {
          return response.json();
        }).then((response) => {
          if(response.data){
            this.managerObjectivesList = response.data.objectivesEmployee;
          }
        });
      },
      filterSkills: function (skillsList){
        return skillsList.filter(function (skill) {
          return skill.key > 5 || skill.key === 0;
        });
      },
    },
    watch: {
        date() {
            this.dateFormatted = this.formatDate(this.date)
        },
        '$i18n.locale': function() {
          this.loadRefTopicData();
          this.loadReview();
        },
      'employeeData.reviewFirstPart': {
        handler: function () {
          if (!this.initialLoad) {
            this.savePartOneAndTwoWithTimer();
          }
        },
        deep: true,
      },
      'employeeData.reviewSecondPart': {
        handler: function () {
          if (!this.initialLoad) {
            this.savePartThreeAndFourWithTimer();
          }
        },
        deep: true,
      },
    },
    computed: {
        positionItems() {
            return ["", this.$t('pdr.part3.Headquarter'), this.$t('pdr.part3.OperationsCountries'), this.$t('pdr.part3.HeadquarterorOperations')]},
        timeframeMobilityItems() {
            return ["", this.$t('pdr.part3.Shortterm'), this.$t('pdr.part3.Mediumterm'), this.$t('pdr.part3.Longterm')]},
        overallPerformanceItems() {
            return [
              {
                key: 0,
                value: ""
              },
              {
                key: 1,
                value: this.$t('pdr.part2.Performancebelow')
              },
              {
                key: 2,
                value: this.$t('pdr.part2.Performanceatrequired')
              },
              {
                key: 3,
                value: this.$t('pdr.part2.Goodlevelofperformance')
              },
              {
                key: 4,
                value: this.$t('pdr.part2.Exceptionnalperformance')
              },
              {
                key: 6,
                value: this.$t('pdr.part2.NEW_SKILS.DoesNotMeet')
              },
              {
                key: 7,
                value: this.$t('pdr.part2.NEW_SKILS.PartiallyMeets')
              },
              {
                key: 8,
                value: this.$t('pdr.part2.NEW_SKILS.Meets')
              },
              {
                key: 9,
                value: this.$t('pdr.part2.NEW_SKILS.MeetsAndExceeds')
              },
              {
                key: 10,
                value: this.$t('pdr.part2.NEW_SKILS.Outstanding')
              },
              {
                key: 11,
                value: this.$t('pdr.part2.NEW_SKILS.NA')
              }
            ]},
        cultureAndValuesItems() {
            return [
              {
                key: 0,
                value: ""
              },
              {
                key: 1,
                value: this.$t('pdr.part2.Developmentrequired')
              },
              {
                key: 2,
                value:  this.$t('pdr.part2.Developmentopportunity')
              },
              {
                key: 3,
                value: this.$t('pdr.part2.Meetsexpectations')
              },
              {
                key: 4,
                value: this.$t('pdr.part2.Strength')
              },
              {
                key: 6,
                value: this.$t('pdr.part2.NEW_SKILS.DoesNotMeet')
              },
              {
                key: 7,
                value: this.$t('pdr.part2.NEW_SKILS.PartiallyMeets')
              },
              {
                key: 8,
                value: this.$t('pdr.part2.NEW_SKILS.Meets')
              },
              {
                key: 9,
                value: this.$t('pdr.part2.NEW_SKILS.MeetsAndExceeds')
              },
              {
                key: 10,
                value: this.$t('pdr.part2.NEW_SKILS.Outstanding')
              },
              {
                key: 11,
                value: this.$t('pdr.part2.NEW_SKILS.NA')
              }
            ]},
        technicalSkillsItems() {
            return [
              {
                key: 0,
                value: ""
              },
              {
                key: 1,
                value: this.$t('pdr.part2.Donotmaster')
              },
              {
                key: 2,
                value: this.$t('pdr.part2.Partiallymasters')
              },
              {
                key: 3,
                value: this.$t('pdr.part2.Masters')
              },
              {
                key: 4,
                value: this.$t('pdr.part2.Perfectlymasters')
              },
              {
                key: 6,
                value: this.$t('pdr.part2.NEW_SKILS.DoesNotMeet')
              },
              {
                key: 7,
                value: this.$t('pdr.part2.NEW_SKILS.PartiallyMeets')
              },
              {
                key: 8,
                value: this.$t('pdr.part2.NEW_SKILS.Meets')
              },
              {
                key: 9,
                value: this.$t('pdr.part2.NEW_SKILS.MeetsAndExceeds')
              },
              {
                key: 10,
                value: this.$t('pdr.part2.NEW_SKILS.Outstanding')
              },
              {
                key: 11,
                value: this.$t('pdr.part2.NEW_SKILS.NA')
              }
            ]},
            leadershipItems() {
            return [
              {
                key: 0,
                value: ""
              },
              {
                key: 1,
                value: this.$t('pdr.part2.Developmentrequired')
              },
              {
                key: 2,
                value: this.$t('pdr.part2.Developmentopportunity')
              },
              {
                key: 3,
                value: this.$t('pdr.part2.Meetsexpectations')
              },
              {
                key: 4,
                value: this.$t('pdr.part2.Strength')
              },
              {
                key: 5,
                value: "N/A"
              },
              {
                key: 6,
                value: this.$t('pdr.part2.NEW_SKILS.DoesNotMeet')
              },
              {
                key: 7,
                value: this.$t('pdr.part2.NEW_SKILS.PartiallyMeets')
              },
              {
                key: 8,
                value: this.$t('pdr.part2.NEW_SKILS.Meets')
              },
              {
                key: 9,
                value: this.$t('pdr.part2.NEW_SKILS.MeetsAndExceeds')
              },
              {
                key: 10,
                value: this.$t('pdr.part2.NEW_SKILS.Outstanding')
              },
              {
                key: 11,
                value: this.$t('pdr.part2.NEW_SKILS.NA')
              }
            ]},
        options() {
            return {
                duration: this.duration,
                offset: this.offset,
                easing: this.easing,
            }
        },
        ...mapGetters({
            home: "getHome",
            labels: "getLabels",
            user: "auth/user",
            locale: "getLocale",
            
        }),
    },
    mounted: function () {
        
        this.loadReview();
        this.loadRefTopicData();
    }
}
</script>
